import "./millennium.browser.scss"
import { Client, Session, EventEmitter, getDefaultSession, getCurrentHost } from "lib/wts.client"
import { IMillenniumBrowser, IMillenniumFrame, IRoute, ICommand, FeedBackData, LazyLoadFacet, MsgBoxFlags, MsgBoxResult, IMillenniumNativeFrame, IModalWindow, IModalWindowOptions, INotificationSource, INotificationItem } from 'lib/millennium.core'
import { loadModule, loadExtension, loadNotifiers } from "../millennium.modules"
import { CommandDialogWindow, Dialog, DialogWindowCommand, getTopOverlayElement, Menu } from "lib/wts.ui.overlays"
import { Onboarding, OnboardingItem } from "lib/wts.ui.onboarding"
import { Feedback } from "lib/wts.ui.feedback"
import { LoadIndicator } from "lib/wts.ui.indicators"
import { Md5 } from 'ts-md5'
import { Environment } from "lib/wts.platform"
import { register } from "lib/wts.ui.register"
import browserHtmlTemplate from "./millennium.browser.html"
import "lib/wts.ui.controls.tree";
import { MlnTreeView } from "lib/wts.ui.controls.tree";
import { favoritesService, FavoriteItem } from "../services/favorites.service"
import { Capacitor } from "@capacitor/core"
import { LiveUpdate } from "@capawesome/capacitor-live-update"
import { showPrompt2FA, showEnroll2FA, isTwoFactorError } from "./millennium.2fa"
import { ConnectivityService } from "lib/connectivity.service"

const mlnFrameInstanceSymbol = Symbol()
const mlnModuleInstanceSymbol = Symbol()
const mlnTabSheetSymbol = Symbol()


export async function showLogin(options?: { message?: string, blank?: boolean, canCancel?: boolean }) {
    const dialogContent = document.createElement("div")
    dialogContent.className = "login-dialog-modal_body"
    dialogContent.id = "login-div"
    dialogContent.style.padding = "10px"
    dialogContent.style.background = "transparent"
    dialogContent.style.maxWidth = "14rem"
    dialogContent.innerHTML = /*html*/ ` 
                    <mln-logo-image style="--logo-text-color:black;margin:10px"></mln-logo-image>

                    <div id="login-dialog-modal_message"></div>
                    <!-- user -->
                    <div class="flex-row flex-align-center form-control input-area">
                        <span class="input-group-addon fa fa-user"
                            style="background:none;border:none;padding:0px 5px 0px 0px"></span>
                        <input autocomplete="off" class="" id="username" type="text"
                            placeholder="Usuário" style="border:none;background:none">
                    </div>
                    <!-- pass -->
                    <div class="flex-row flex-align-center form-control input-area">
                        <span class=" input-group-addon fa fa-key"
                            style="background:none;border:none;padding:0px 5px 0px 0px"></span>
                        <input autocomplete="off" class="" id="password" type="password" 
                            placeholder="Senha" style="border:none;background:none"/>
                    </div>
                    <div style="height:20px"></div>
                    <div class="login-dialog-modal_buttons mln-button-area" style="margin-top:auto">
                        <button id="login_modal" class="mln-button"
                            >ENTRAR</button>
                        <button id="login_cancel_modal" class="mln-button"
                           >CANCELAR</button>                        
                    </div>
                    `

    const dialog = new Dialog()

    if (!options?.blank) {
        const usernameEl = dialogContent.querySelector<HTMLInputElement>("#username")
        if (usernameEl) {
            usernameEl.value = getDefaultSession().userName
            usernameEl.disabled = true
        }
    }
    const cancelBtn = dialogContent.querySelector<HTMLInputElement>("#login_cancel_modal")
    if (cancelBtn)
        cancelBtn.hidden = !options?.canCancel

    const messageEl = dialogContent.querySelector<HTMLDivElement>("#login-dialog-modal_message")
    if (messageEl)
        messageEl.innerText = options?.message ?? ""

    const buttonsEl = dialogContent.querySelector<HTMLDivElement>(".login-dialog-modal_buttons")
    if (buttonsEl)
        buttonsEl.onclick = (e: Event) => {
            if (!(e.target instanceof HTMLButtonElement)) return
            dialog.close(e.target.id)
        }
    dialogContent.onkeydown = (e: KeyboardEvent) => {
        if (e.key === "Enter") {
            dialog.close("login_modal")
        }
        if (e.key === "Escape") {
            dialog.close("login_cancel_modal")
        }
    }

    let username: string | undefined
    let password: string | undefined
    const dialogResult = await dialog.show(dialogContent, {
        className: "login-dialog-modal",
        lightDismiss: false,
        width: "auto",
        height: "auto",
        minHeight: "fit-content",
        topLayer: true,
        closeCallback: (result?: string) => {
            if (result === "login_modal") {
                const usernameEl = dialogContent.querySelector<HTMLInputElement>("#username")
                const passwordEl = dialogContent.querySelector<HTMLInputElement>("#password")
                if (usernameEl)
                    username = usernameEl.value
                if (passwordEl)
                    password = passwordEl.value

                if (!username || !password) return false
            }
            return true
        }
    })

    dialogContent.remove()

    return dialogResult === "login_modal" && username && password ? { username, password } : undefined
}


class NativeFrame implements IMillenniumNativeFrame {
    resize(left: number, top: number, width: number, height: number, visible: number): void {
        return this.browser.resizeNativeFrame(this.handle, left, top, width, height, visible)
    }
    navigate(place: string): void {
        return this.browser.navigateNativeFrame(this.handle, place)
    }
    destroy(): void {
        return this.browser.destroyNativeFrame(this.handle)
    }
    constructor(private browser: MillenniumBrowser, private handle: number) {

    }
}

class MlnActivityIndicator extends HTMLElement {
    connectedCallback() {
        this.innerHTML =  /*html*/`        
        <div class="pos-activity-panel flex-col flex-align-center" style="margin:auto">              
                <div class="windows8" style="width:50px;height:50px;position:relative">
                   
                    <div class="wBall" id="wBall_1">
                        <div class="wInnerBall">
                        </div>
                    </div>
                    <div class="wBall" id="wBall_2">
                        <div class="wInnerBall">
                        </div>
                    </div>
                    <div class="wBall" id="wBall_3">
                        <div class="wInnerBall">
                        </div>
                    </div>
                    <div class="wBall" id="wBall_4">
                        <div class="wInnerBall">
                        </div>
                    </div>
                    <div class="wBall" id="wBall_5">
                        <div class="wInnerBall">
                        </div>
                    </div>
                </div>
                <div class="pos-activity-panel-message" style="margin-top:5px;text-align:center;font-size:120%;color:white"></div>
                <button class="command-btn cancel-btn" style="display:none"><i class="far fa-times" style="margin-right: 5px; pointer-events: none;"></i><span style="pointer-events: none;">Cancelar</span></button>
            </div>
        `
        this._cancelBtn = this.querySelector<HTMLButtonElement>(".cancel-btn")
        if (this._cancelBtn) {
            this._cancelBtn.onclick = this.handleClick
        }

        this._messageEl = this.querySelector<HTMLElement>(".pos-activity-panel-message")
        this.style.position = "absolute"
        this.style.left = "0"
        this.style.top = "0"
        this.style.right = "0"
        this.style.bottom = "0"
        this.style.background = "rgba(0,0,0,0.5)"
        this.style.zIndex = "1000"
        this.style.display = this._active ? "flex" : "none"
    }
    private _messageEl: HTMLElement | undefined | null
    private _cancelBtn: HTMLElement | undefined | null
    private _active = false
    private _timeout: any
    private _refCount = 0
    private _caption = ""
    private _transaction = ""
    set active(value: boolean) {
        if (this._active === value) return
        this._active = value
        const element = this.querySelector<HTMLElement>(".pos-activity-panel")
        this._active ? element?.removeAttribute("hidden") : element?.setAttribute("hidden", "")

        clearTimeout(this._timeout)
        this._timeout = setTimeout(() => {
            this.style.display = this._active ? "flex" : "none"
        }, value ? 500 : 50)
    }
    get active() {
        return this._active
    }

    handleClick = async (e: Event) => {
        if (!e.target) return
        if (this._cancelBtn?.style.cursor === "progress") return

        if (this._cancelBtn) this._cancelBtn.style.cursor = "progress"

        e.preventDefault()

        const result = (await Client.get<any>("WTSSYSTEM.TASKS.LIST", {})).value
        const tasks = result.filter(t => t.CURRENT_COMMAND == this._transaction &&
            t.USERNAME == millennium.browser.userName &&
            t.USERGROUP == millennium.browser.userGroup)
        for (let item of tasks)
            await Client.get<any>("WTSSYSTEM.TASKS.CANCEL", { REQUESTID: item.REQUESTID })

    }


    transaction(value: string) {
        this._transaction = value
        if (this._cancelBtn) {
            this._cancelBtn.style.display = ""
            this._cancelBtn.style.cursor = "pointer"
        }
    }

    begin() {
        this._refCount++
        if (this._refCount === 1) this.active = true
    }
    end() {
        this._refCount--
        if (this._refCount <= 0) this.active = false
    }
    get caption() {
        return this._caption
    }
    set caption(value: string) {
        this._caption = value
        if (this._messageEl) this._messageEl.innerText = value
    }
}

register("mln-activity-indicator", MlnActivityIndicator)
declare global {
    interface HTMLElementTagNameMap {
        "mln-activity-indicator": MlnActivityIndicator
    }
}

class MlnLogoImage extends HTMLElement {
    connectedCallback() {
        const shadow = this.attachShadow({ mode: "closed" })
        shadow.innerHTML = `
        <svg style="margin-bottom: 20px;width:100%;"
            viewBox="0 0 137 40" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">            
            <path fill="currentColor" d="M31.8573 8.19423c-.2058-.7611-.6998-1.44361-1.3955-1.97307C26.8064 3.46631 22.4677 1.40224 17.742.177866 17.285.0579097 16.8116 0 16.3341 0s-.9509.0579097-1.4078.177866C10.2006 1.40224 5.85773 3.46631 2.21054 6.22116c-.69568.52533-1.18966 1.21197-1.39548 1.97307C.271687 10.1963 0 12.2355 0 14.2748v10.6016c0 2.0392.271687 4.0785.81506 6.0805.20582.7611.6998 1.4436 1.39548 1.9731 3.6513 2.7548 7.99416 4.8189 12.71576 6.0433.4569.1199.9303.1778 1.4078.1778s.9509-.0579 1.4079-.1778c4.7257-1.2244 9.0685-3.2885 12.7157-6.0433.6957-.5254 1.1897-1.212 1.3955-1.9731.5434-2.002.8151-4.0413.8151-6.0805V14.2748c0-2.0393-.2717-4.0785-.8151-6.08057zm-.4528 12.07007c-.1852.6783-.6175 1.2905-1.2596 1.7745-1.7907 1.3526-3.7666 2.5439-5.8742 3.5449-2.1077 1.001-4.3511 1.8117-6.6687 2.4157-.4116.1075-.8356.1613-1.2679.1613-.4322 0-.8562-.0538-1.2678-.1613-2.3176-.5998-4.5611-1.4147-6.66872-2.4157s-4.08353-2.1964-5.87419-3.5449c-.63805-.484-1.0744-1.0962-1.25964-1.7745-.12349-.455-.12349-.9349 0-1.3899.18524-.6783.61747-1.2905 1.25964-1.7745 1.79066-1.3526 3.76657-2.5439 5.87419-3.5449s4.35112-1.8117 6.66872-2.4156c.4116-.1076.8356-.1614 1.2678-.1614.4323 0 .8563.0538 1.2679.1614 2.3176.5997 4.561 1.4146 6.6687 2.4156 2.1076 1.001 4.0835 2.1965 5.8742 3.5449.638.484 1.0744 1.0962 1.2596 1.7745.1235.455.1235.9349 0 1.3899m10.6744-6.3739c-.7986 0-1.2391-.4343-1.2391-1.2079V9.75397h16.717v2.92853c0 .7694-.4405 1.2079-1.2391 1.2079h-4.7545v15.495h-4.7257v-15.495zm27.6747 11.2427c1.1567-.5129 1.9841-1.0961 2.968-1.8572.7286-.5667 1.0991-1.3319 1.1855-2.2089.1276-1.245.1317-1.7414 0-2.9864-.0864-.8356-.4775-1.6256-1.1855-2.1799-.9715-.8066-1.7948-1.3775-2.968-1.8904-.3622-.1613-.7945-.2482-1.2596-.2482-.4652 0-.8974.0869-1.2597.2482-1.1732.5129-1.9964 1.0838-2.9679 1.8904-.7081.5543-1.0991 1.3484-1.1856 2.1799-.1317 1.245-.1276 1.7414 0 2.9864.0906.877.4528 1.6339 1.1856 2.2089.9756.7694 1.8071 1.3485 2.9679 1.8572.3746.1614.7945.2193 1.2597.2193.4651 0 .8809-.0579 1.2596-.2193m-4.3387 4.215c-1.3749-.5377-2.9968-1.3608-4.1659-2.2378-1.7083-1.274-2.7704-3.2346-3.0091-5.3566-.1688-1.5098-.1688-2.8541 0-4.3639.2387-2.122 1.3008-4.0827 3.0091-5.3277 1.1732-.9059 2.7868-1.7414 4.1659-2.28332.9509-.37641 1.9841-.65769 3.0832-.65769s2.1282.28542 3.0832.65769c1.3914.54602 2.9968 1.37742 4.1659 2.28332 1.7083 1.245 2.7704 3.2057 3.0091 5.3277.1688 1.5098.1688 2.8541 0 4.3639-.2387 2.122-1.3008 4.0826-3.0091 5.3566-1.1732.877-2.7786 1.7001-4.1659 2.2378-.9838.3806-1.9841.6743-3.0832.6743s-2.0994-.2896-3.0832-.6743m15.2597-15.4578c-.7986 0-1.2391-.4343-1.2391-1.2078V9.75391h16.717v2.92859c0 .7694-.4405 1.2078-1.239 1.2078h-4.7546v15.495h-4.7257v-15.495zm24.6174 14.7802-5.191-6.73c-.3748-.4757-.5024-.8976-.5024-1.485V9.75879h3.4334c.765 0 1.202.42191 1.202 1.20781v8.5376c0 .5873.123 1.0382.502 1.5015l3.462 4.3184 3.305-4.3184c.35-.4757.503-.91.503-1.5015v-8.5376c0-.7694.42-1.20781 1.202-1.20781h3.433V20.4555c0 .5874-.153 1.0217-.502 1.5016l-5.134 6.7175c-.378.5046-.835.7156-1.465.7156h-2.775c-.642 0-1.086-.211-1.465-.7156m14.383-5.6142h3.634c.848 0 .988.2896 1.227 1.1003.338 1.1541 1.33 1.7621 3.359 1.7621h1.079c2.087 0 3.169-.6452 3.169-1.9358v-.4261c0-.7941-.687-1.3071-2.041-1.5552l-4.598-.8356c-3.285-.5874-5.488-2.1551-5.488-5.0464v-1.1293c0-3.6235 3.228-5.69167 7.081-5.69167h2.206c4.615 0 7.212 2.46527 7.212 6.33697h-3.68c-.729 0-.943-.1737-1.095-.7776-.276-1.0838-1.05-1.6298-2.7-1.6298h-1.256c-1.474 0-2.919.4095-2.919 1.7456v.455c0 .7032.626 1.2037 1.915 1.4229l4.804.8645c3.198.5709 5.417 2.0558 5.417 5.092v1.1747c0 3.9296-3.462 5.882-7.607 5.882h-1.985c-4.511 0-7.722-2.0558-7.722-6.8086"></path>                    
        </svg>
        `
    }
}

register("mln-logo-image", MlnLogoImage)

const FRAMES = Symbol("FRAMES")

interface IWorkspaceConfigEntry {
    workspace: string        // match com route.text
    order?: number           // ordem ascendente; sem order = fim
    homeKey?: string         // override do "Portal" — match case-insensitive com urlKey/key
    icon?: string            // nome do SVG em /images
}

export class MillenniumBrowser extends HTMLElement implements IMillenniumBrowser {

    [FRAMES]: Set<MillenniumFrame> = new Set()
    _activeFrame?: IMillenniumFrame
    private _workspacesConfig: Map<string, IWorkspaceConfigEntry> = new Map()

    hasFrame(key: string): boolean {
        for (const frame of this[FRAMES])
            if (frame.key === key)
                return true

        return false
    }
    getVersionInfo(): PromiseLike<string> {
        throw new Error("Method not implemented.")
    }
    session = getDefaultSession();
    get onAuthFail(): EventEmitter { return this.session.onAuthFail }
    get onLoginDone(): EventEmitter { return this.session.onLoginDone }

    lastNotificationTime?: number
    lastNotificationMsg?: string
    lastNotificationEl?: HTMLElement
    isEmbedded = false;
    win_activate() {
        const module = (this.querySelector(".mln-content-frame.visible") as any)?.data("mln-module-instance")
        if (module) void module.activate?.()
    }

    win_notify(message: string, type: "warning" | "danger" | "success" | "warning-auto-hide" = "success") {
        const notification = document.createElement("div")
        notification.className = `alert alert-${type} visible`
        this.lastNotificationEl = notification

        const closeBtn = document.createElement("a")
        closeBtn.className = "close pull-right"
        closeBtn.style.cursor = "pointer"
        closeBtn.innerHTML = "&times;"
        closeBtn.onclick = () => notification.remove()

        notification.append(closeBtn)
        notification.insertAdjacentHTML("beforeend", message)
        const topRight = this.querySelector(".top-right")
        if (topRight)
            topRight.appendChild(notification)
        setTimeout(() => {
            notification.remove()
        }, 10000)
    }
    notify(message: string | Error, type: "warning" | "danger" | "success" | "warning-auto-hide") {
        let msgText = typeof message === "string" ? message : message.message
        if (msgText.startsWith("Remote Call Error")) {
            console.error(msgText)
            if (msgText.includes(String.fromCharCode(13)))
                msgText = msgText.slice(msgText.indexOf(String.fromCharCode(13)) + 2)
        }

        //ignora a repeticao da mesma mensagem apenas enquanto ela ainda estiver
        //visivel na tela; se ja foi fechada/expirou, dispara de novo mesmo dentro
        //da janela de 5s (senao a mensagem ficaria "engolida" por tempo).
        if (Date.now() - (this.lastNotificationTime ?? 0) > 5000 || this.lastNotificationMsg !== msgText || !this.lastNotificationEl?.isConnected) {
            this.lastNotificationMsg = msgText
            this.lastNotificationTime = Date.now()
            this.win_notify(msgText, type)
        }
    }
    activity<T extends PromiseLike<any>>(waiter: T, element: HTMLElement, feedBackData?: FeedBackData, silent?: boolean): T {
        if (!waiter.then) return waiter

        let currentMessage = 1
        let messageTimer: any | undefined
        const targetEl = feedBackData?.element ?? element ?? getTopOverlayElement()

        let activityEl = targetEl.querySelector(":scope > mln-activity-indicator") as MlnActivityIndicator | undefined
        if (!activityEl) {
            activityEl = document.createElement("mln-activity-indicator")
            targetEl.appendChild(activityEl)
        }
        activityEl.begin()

        const handleError = (error: any) => {
            if (!silent) this.notify(error, "warning")
            activityEl?.end()
            clearInterval(messageTimer)
            return Promise.reject(error) as any
        }

        try {
            if (feedBackData) {
                if (activityEl)
                    activityEl.caption = (feedBackData.waitMessages?.[0]) ?? ""
                if (feedBackData.waitMessages && feedBackData.estimatedTime)
                    messageTimer = setInterval(() => {
                        if (activityEl)
                            activityEl.caption = feedBackData.waitMessages?.[currentMessage] ?? ""
                        currentMessage++
                        if (currentMessage >= (feedBackData.waitMessages?.length ?? 0)) clearInterval(messageTimer)
                    }, feedBackData.estimatedTime / feedBackData.waitMessages.length)
            } else if (activityEl)
                activityEl.caption = ""

            return waiter.then((result: any) => {
                activityEl?.end()
                clearInterval(messageTimer)
                return result
            }, handleError) as any
        } catch (error: any) {
            return handleError(error)
        }
    }
    async switchUser(): Promise<void> {
        const defSession = this.session
        await defSession.logout(true)
        const newSession = new Session()

        let loginInfo
        do {
            loginInfo = await showLogin({ blank: true, message: "Entre com um usuário do grupo " + defSession.userGroup, canCancel: false })

            if (loginInfo) {
                try {
                    await newSession.login(this.session.appName, this.session.licenceName, this.session.host, loginInfo.username, loginInfo.password)
                    if (newSession.userGroup !== defSession.userGroup) {
                        await newSession.logout()
                        throw Error("O usuário deve ser do grupo " + defSession.userGroup)
                    }
                } catch (e: any) {
                    this.notify(e, "warning")
                    loginInfo = undefined
                }
            }
        } while (!loginInfo)

        newSession.onAuthFail.assign(defSession.onAuthFail)
        newSession.onLoginDone.assign(defSession.onLoginDone)
        newSession.isDefault = true
        this.session = newSession

        defSession.destroy()

        this.loginDone()
    }
    msgBox(message: string, title: string, flags: number): Promise<number> {
        const dialog = new CommandDialogWindow()

        const msg = document.createElement("div")
        msg.innerText = message
        msg.style.textAlign = "center"
        msg.style.padding = "30px"
        msg.style.fontSize = "110%"
        msg.style.display = "flex"
        msg.style.alignItems = "center"
        msg.style.justifyContent = "center"

        let commands: DialogWindowCommand[] = []

        if (flags & MsgBoxFlags.MB_OK || flags === 0)
            commands = [{ caption: "OK", id: MsgBoxResult.IDOK }]
        else if (flags & MsgBoxFlags.MB_OKCANCEL)
            commands = [{ caption: "OK", id: MsgBoxResult.IDOK }, { caption: "Cancelar", id: MsgBoxResult.IDCANCEL }]
        else if (flags & MsgBoxFlags.MB_YESNO)
            commands = [{ caption: "Sim", id: MsgBoxResult.IDYES }, { caption: "Não", id: MsgBoxResult.IDNO }]
        else if (flags & MsgBoxFlags.MB_YESNOCANCEL)
            commands = [{ caption: "Sim", id: MsgBoxResult.IDYES }, { caption: "Não", id: MsgBoxResult.IDNO }, { caption: "Cancelar", id: MsgBoxResult.IDCANCEL }]
        else if (flags & MsgBoxFlags.MB_RETRYCANCEL)
            commands = [{ caption: "Sim", id: MsgBoxResult.IDYES }, { caption: "Retentar", id: MsgBoxResult.IDRETRY }, { caption: "Cancelar", id: MsgBoxResult.IDCANCEL }]

        return dialog.show(msg, {
            title,
            commands,
            width: "fit-content",
            height: "fit-content",
            minWidth: "320px",
            minHeight: "160px",
            commandBarStyle: "clear"
        })
    }
    //frame callbacks
    frame_navigateSc = (frame: IMillenniumFrame | undefined, key: string, data: string, vars: Object, caption?: any) => {
        return this.load(undefined/*force new tab*/, key, undefined, vars, false, frame ?? this._activeFrame)
    };
    frame_navigate = (frame: IMillenniumFrame | undefined, data: string, vars: Object) => {
        return this.load(undefined/*force new tab*/, "", data, vars, false, frame ?? this._activeFrame)
    };
    frame_close = (frame: IMillenniumFrame) => { };
    frame_setCaption = (frame: IMillenniumFrame, value: string) => { };
    frame_setUrl = (frame: IMillenniumFrame, value: string) => { };
    frame_activity = (frame: IMillenniumFrame, value: string) => { };
    frame_activate = (frame: IMillenniumFrame) => { };
    frame_deactivate = (frame: IMillenniumFrame) => { };
    frame_notify = (frame: IMillenniumFrame, message: string, type: string) => { };
    frame_initialized = () => { };
    frame_create: () => IMillenniumFrame = () => new MillenniumFrame(this);
    createFrame(): IMillenniumFrame {
        return this.frame_create()
    }
    async createFrameAsNative() {
        const handle = await this.createNativeFrame()
        return new NativeFrame(this, handle)
    }
    private rootRoutes?: IRoute[]
    async getVersion() {
        if (this.isEmbedded)
            return {}
        else {
            return {
                "millennium": await this.getVersionInfoMillennium(),
                "omni": await this.getVersionInfoOmnichannel()
            }
        }
    }
    async getObjectActions(objectName: string): Promise<ICommand[]> {
        //todo: read from api
        return []
    }

    /**
     * Modo de contingência OFFLINE. Quando ativo, o boot do browser NÃO consulta o broker
     * (login, /api/routes/ACL, notificações remotas) e usa recursos locais estáticos
     * (./millennium.routes.json e workspaces embarcados no bundle). Ativado pelo entry de
     * contingência via `millennium.offline = true` antes de instanciar o <millennium-browser>.
     */
    get offlineMode(): boolean {
        return millennium?.offline === true
    }

    // ─── Conectividade (detecção via heartbeat) ──────────────────────────────────────────────
    // O browser é o dono do estado de disponibilidade do broker: o heartbeat (keepAlive) faz o
    // ping de alcance, atualiza este serviço e, por tabela, `Client.onLine` (consumido pelas
    // páginas em `if (!Client.onLine)`). Aqui só EXPOMOS o estado para quem precisa reagir (ex.:
    // a página de contingência). Tocar em `.instance` já registra o probe em `Client`.
    private readonly _connectivity = ConnectivityService.instance
    private readonly _onlineListeners = new Set<(online: boolean) => void>()
    private _onlineFanoutWired = false

    private wireOnlineFanout() {
        if (this._onlineFanoutWired) return
        this._onlineFanoutWired = true
        this._connectivity.onChange.subscribe((value: boolean) => {
            for (const cb of this._onlineListeners) {
                try { cb(value) } catch (e) { console.error("onlineChange listener error", e) }
            }
        })
    }

    /** Disponibilidade do broker, conforme o último heartbeat. */
    get online(): boolean {
        return this._connectivity.available
    }

    /** Subscreve mudanças de disponibilidade; retorna função para cancelar (sem o bug do EventEmitter.unsubscribe). */
    onlineChange(callback: (online: boolean) => void): () => void {
        this.wireOnlineFanout()
        this._onlineListeners.add(callback)
        return () => { this._onlineListeners.delete(callback) }
    }

    async getRoutes(session: Session = this.session) {
        let routes: (IRoute & {
            id: string,
            appname?: string
        })[] = []

        try {
            routes = await Client.getJSON<any>("./millennium.routes.json")
        }
        catch { }

        // Em contingência (offline) não há broker: usa apenas as rotas locais estáticas
        // (./millennium.routes.json embarcado no bundle); o ACL remoto (/api/routes) é ignorado.
        const acl = this.offlineMode ? [] : await Client.getJSON<(IRoute & {
            id: string
        })[]>(session.host + "/api/routes", { appname: session.appName, moduleType: "html" }, session)

        if (routes) {

            const clientRoutes = routes.filter(e => e.appname === session.appName).map(e => {
                return { ...e, id: e.urlKey, key: e.urlKey, _client: true, _preloaded: true }
            })

            const adjustedRoutes = []
            for (let route of routes) {
                if (acl.findIndex(e => e.key === route.urlKey) >= 0 || route.urlKey === "start") {
                    route["id"] = route.urlKey
                    route["key"] = route.urlKey;
                    (route as any)["_preloaded"] = true
                    adjustedRoutes.push(route)
                }
            }
            routes = [...clientRoutes, ...(adjustedRoutes.length ? adjustedRoutes : acl)]
        }
        else
            routes = acl

        /*for (const route of routes)
            if (route.text && !route.icon) {
                route.icon = route.text.toLowerCase().replaceAll(" ", "_");
            }*/

        this.rootRoutes = routes
        return routes
    }
    private async loadWorkspacesConfig(): Promise<void> {
        this._workspacesConfig = new Map()
        try {
            const arr = await Client.getJSON<IWorkspaceConfigEntry[]>("./millennium.workspaces.json")
            if (!Array.isArray(arr)) return
            for (const entry of arr) {
                if (!entry || typeof entry.workspace !== "string") continue
                const prev = this._workspacesConfig.get(entry.workspace)
                this._workspacesConfig.set(entry.workspace, { ...prev, ...entry })
            }
        } catch { /* ausente/malformado = nenhum override */ }
    }
    async getRoute(key: string, data?: string, session: Session = this.session): Promise<IRoute> {

        if (key.startsWith("$"))
            return {
                target: key.slice(1).toLocaleLowerCase(),
                text: "",
                urlKey: key,
                icon: ""
            }

        let cachedRoute: IRoute | undefined
        if (session === this.session && this.rootRoutes) {
            cachedRoute = this.rootRoutes.find(e => (e.urlKey || e.key || "").toLowerCase() === (key || data || "").toLowerCase())
            if (cachedRoute && cachedRoute.target)
                return Promise.resolve(cachedRoute)
        }
        const route = await Client.getJSON<IRoute>(session.host + "/api/routes", { key: key || "", data: data || "" }, session)
        if (!cachedRoute && this.rootRoutes) {
            cachedRoute = { key } as IRoute
            this.rootRoutes.push(cachedRoute)
        }
        for (let k in route)
            (cachedRoute as any)[k] = (route as any)[k]

        if (cachedRoute && cachedRoute.target === "")
            cachedRoute.target = "_"

        if (key === "" && cachedRoute)
            cachedRoute.urlKey = data || ""

        // Cache-MISS deve retornar a rota ENRIQUECIDA (cachedRoute), não a resposta crua do
        // servidor. A resposta do /api/routes traz o `target` mas NÃO o `text`/caption amigável;
        // o `text` vem do millennium.routes.json e já está no cachedRoute. Retornar `route` cru
        // fazia a 1ª abertura ficar sem título (só o cache-HIT — 2ª abertura — retornava o
        // cachedRoute com `text`). Igualar ao cache-HIT (linha ~599) corrige a assimetria
        // "2ª vez tem título, 1ª não".
        return cachedRoute ?? route
    }
    get inLogin() {
        return this.session.inLogin
    }
    showUserInfo() {
        function getGravatarImage(email: string, args?: any) {
            args = args || ""
            var BASE_URL = "https://www.gravatar.com/avatar/"
            return (BASE_URL + ((email) ? (Md5.hashStr(email.toLowerCase().trim()) + "?") : "?d=mm&") + args).trim()
        }
        if (!this.isEmbedded) {
            try {
                const usrImg = this.querySelector("#usr-img")
                if (usrImg)
                    usrImg.setAttribute("src", getGravatarImage(this.session.getLoggedUserInfo().employeeEmail || this.session.getLoggedUserInfo().employeeName, "s=28"))
            } catch (error: any) {
                this.notify(error, "warning")
            }
            const employeeName = this.querySelector("#employee-name")
            if (employeeName)
                employeeName.textContent = this.userName
        }
    }
    loginDone() {
        this.session.isDefault = true
        this.showUserInfo()
        this.session.loginDone()
        if (this.onLoginDone)
            this.onLoginDone.trigger()
    }
    async login(appName: string, licenceName: string, host: string, userName: string, passWord: string, twoFactorCode: string = "") {
        const sessionData = await this.session.login(appName, licenceName, host, userName, passWord, [], twoFactorCode)

        this.loginDone()

        return sessionData
    }

    accessList = new Map<string, Set<string>>();
    private accessListLoading = new Map<string, Promise<Set<string>>>();
    private readonly accessCacheMaxItems = 5000
    private readonly accessCacheMaxKeyLength = 200
    private getSessionUserKey(session: Session): string {
        return String(session.userName || "").trim().toLowerCase()
    }
    private matchSessionUser(session: Session, rawUserName: unknown): boolean {
        const expectedUser = this.getSessionUserKey(session)
        if (!expectedUser) return true
        return String(rawUserName || "").trim().toLowerCase() === expectedUser
    }
    private toBase64Utf8(value: string): string {
        return btoa(unescape(encodeURIComponent(value)))
    }
    private fromBase64Utf8(value: string): string {
        return decodeURIComponent(escape(atob(value)))
    }
    private getAccessCacheStorageKey(session: Session): string {
        return `millennium.routes.grants.${encodeURIComponent(session.id || "")}`
    }
    private sanitizeAccessGrantList(grants: unknown): string[] {
        if (!Array.isArray(grants)) return []
        const values: string[] = []
        for (const item of grants) {
            if (typeof item !== "string") continue
            if (!item || item.length > this.accessCacheMaxKeyLength) continue
            values.push(item)
            if (values.length >= this.accessCacheMaxItems) break
        }
        return values
    }
    private readPersistentAccessList(session: Session): Set<string> | undefined {
        try {
            const rawData = localStorage.getItem(this.getAccessCacheStorageKey(session))
            if (!rawData) return
            const cacheData = JSON.parse(rawData)
            if (!cacheData || typeof cacheData !== "object") return
            if (cacheData.version !== 3) {
                this.removePersistentAccessList(session)
                return
            }
            if (cacheData.sessionId !== session.id || cacheData.host !== session.host) return
            if (!this.matchSessionUser(session, cacheData.userName)) return
            if (typeof cacheData.payload !== "string" || !cacheData.payload) return
            const grants = this.sanitizeAccessGrantList(JSON.parse(this.fromBase64Utf8(cacheData.payload)))
            if (grants.length === 0) return
            return new Set<string>(grants)
        } catch {
            return
        }
    }
    private persistAccessList(session: Session, accessSet: Set<string>) {
        try {
            const grants = this.sanitizeAccessGrantList(Array.from(accessSet))
            localStorage.setItem(this.getAccessCacheStorageKey(session), JSON.stringify({
                version: 3,
                sessionId: session.id,
                host: session.host,
                userName: this.getSessionUserKey(session),
                createdAt: Date.now(),
                payload: this.toBase64Utf8(JSON.stringify(grants))
            }))
        } catch { }
    }
    private removePersistentAccessList(session: Session) {
        try {
            localStorage.removeItem(this.getAccessCacheStorageKey(session))
        } catch { }
    }
    private async getSessionAccessList(session: Session): Promise<Set<string>> {
        let accessList = this.accessList.get(session.id)
        if (accessList)
            return accessList

        const persistentData = this.readPersistentAccessList(session)
        if (persistentData) {
            this.accessList.set(session.id, persistentData)
            return persistentData
        }

        let loading = this.accessListLoading.get(session.id)
        if (!loading) {
            loading = (async () => {
                //don´t filter appname, because some permitions are shared between apps (ag: omni & millennium)
                const aclArray = await Client.getJSON<string[] | { key: string }[]>(session.host + "/api/routes", { grants: "true", appname: "" }, session)

                const accessSet = new Set<string>()
                for (const item of aclArray) {
                    if (typeof item === "string")
                        accessSet.add(item)
                    else
                        accessSet.add(item.key)
                }

                this.accessList.set(session.id, accessSet)
                this.persistAccessList(session, accessSet)
                return accessSet
            })()
            this.accessListLoading.set(session.id, loading)
        }

        try {
            return await loading
        } finally {
            this.accessListLoading.delete(session.id)
        }
    }
    async hasAccess(key: string, session?: Session): Promise<boolean> {
        if (!session) session = getDefaultSession()

        const mapKey = `${key}`
        const accessList = await this.getSessionAccessList(session)

        return accessList.has(mapKey)
    }

    async hasPermission(key: string, session?: Session): Promise<boolean> {
        if (!session) session = getDefaultSession()

        const mapKey = `${key}`
        const accessList = await this.getSessionAccessList(session)

        return accessList.has(mapKey)
    }

    async accessPrompt(message: string, key: string, userInfo?: any): Promise<boolean> {
        if (userInfo) userInfo.username = this.userName

        let access
        try {
            access = await this.hasAccess(key)
        } catch { }

        if (access)
            return access
        else {

            const loginInput = await showLogin({ message, canCancel: true, blank: true })

            const session = new Session()
            try {
                if (!loginInput) return false
                await session.login(this.session.appName, this.session.licenceName, this.session.host, loginInput.username, loginInput.password, [key])
                if (userInfo) userInfo.username = loginInput.username

                return true
            } catch (e: any) {
                return false
            } finally {
                session.destroy()
            }
        }
    }
    async logout() {
        this.accessList.delete(this.session.id)
        this.accessListLoading.delete(this.session.id)
        this.removePersistentAccessList(this.session)
        if (this.session.isActive())
            await this.session.logout()

        window.location.reload()
    }
    async decodeRoute(routeKey: string, routeObj: any, vars?: any): Promise<IRoute> {
        if (!routeKey) {
            routeObj = await this.getRoute(routeKey, routeObj)
        } else if (routeKey && !routeObj)
            routeObj = await this.getRoute(routeKey)
        else
            if ((routeObj as any)["_preloaded"]) {
                const route = await this.getRoute(routeKey)
                routeObj = { ...routeObj, ...route }
            }
            else
                routeObj = await this.getRoute(routeKey)

        if (vars && routeObj.params) {
            const params = []
            for (const param of routeObj.params) {
                const item = { ...param }
                for (let key in item)
                    if (typeof item[key] === "string" && item[key].startsWith("{$")) {
                        let varName = item[key].trim().slice(2, -1)
                        if (varName.endsWith("[]")) varName = varName.slice(0, -2)
                        item[key] = vars[varName]
                    }

                params.push(item)
            }
            routeObj = { ...routeObj, params }
        }

        return routeObj
    }

    // ─── Target experimental (dual-target) ──────────────────────────
    // A decisão (target clássico vs target2 novo) é GLOBAL, definida pelo administrador no
    // Controle de Usuários e gravada numa chave única de registro. O client baixa esse conjunto
    // UMA vez por sessão (lazy) e escolhe localmente — sem hit ao servidor por navegação, e sem
    // botão/escolha por-usuário. Mesma mecânica do binbrowser.
    private _expSet?: Set<string>  // ids (chave de acesso, maiúsculo) marcados p/ a versão nova
    private async ensureExpSet(): Promise<Set<string>> {
        if (this._expSet) return this._expSet
        const set = new Set<string>()
        try {
            const res = await Client.get<any>("wtssystem.registry.listraw", { NOME: "MILLENIUM\\WINREG\\0\\TM\\BROWSER\\EXPERIMENTS" }, { neverPost: true }, this.session)
            const row = (res as any)?.value?.[0]
            const blob = String(row?.VALOR_G ?? row?.VALOR_S ?? "")
            for (const line of blob.split(/\r?\n/)) {
                const id = line.trim().toUpperCase()
                if (id) set.add(id)
            }
        } catch { /* offline/sem chave: conjunto vazio = tudo clássico */ }
        this._expSet = set
        return set
    }

    async getVersionInfoOmnichannel(): Promise<string> {
        try {
            const value = await Client.getJSON<any>("chcp.json")
            return value && value.release
        } catch {
            return ""
        }
    }
    async getVersionInfoMillennium(): Promise<string> {
        try {
            const text = await Client.getText(getCurrentHost() + "/files/apps/installedpacks/{8AD628CF-4B83-4A72-8A50-C6835E946B52}.inf")
            return text.split('\r\n').filter(e => e.startsWith("Version"))[0].split("=")[1]
        } catch {
            return ""
        }
    }
    afterLoad?: () => void
    async getSessionId(): Promise<string> {
        return this.session?.id
    }
    navigate(place: string, vars: Object): Promise<void> {
        return this.frame_navigate(undefined, place, vars)
    }
    navigateSc(key: string, data: string, vars: Object, caption?: any): Promise<void> {
        return this.frame_navigateSc(undefined, key, data, vars, caption)
    };
    async load(frame: IMillenniumFrame | undefined, routeKey: string, route?: IRoute | string, vars?: any, noActivate?: boolean, originFrame?: IMillenniumFrame): Promise<any> {
        return LoadIndicator(document.body, this.internalLoad({ frame, routeKey, route, vars, noActivate, originFrame }))
    }

    #currentModuleName = ""
    get currentModuleName() {
        return this.#currentModuleName
    }
    set currentModuleName(name: string) {
        for (const frame of this[FRAMES])
            frame.visible = frame.moduleName === name
        this.#currentModuleName = name
        let activeFrame: MillenniumFrame | undefined
        for (const frame of this[FRAMES]) {
            const fr = frame as MillenniumFrame
            if (fr.moduleName === name && fr.isActive) {
                activeFrame = fr
                break
            }
        }
        if (activeFrame) {
            this._activeFrame = activeFrame
            void activeFrame.activate()
        } else {
            this._activeFrame = undefined
        }
        this.updateFavoriteToggleState()
    }

    /**
     * Desfaz o vínculo de "módulo/aba ativa" quando a última aba visível de um
     * workspace é fechada (sem irmã do mesmo módulo para assumir).
     *
     * Sem isto, `#currentModuleName` fica preso no módulo recém-fechado e o guard
     * `if (this.currentModuleName === moduleName) return` em showModule aborta a
     * REABERTURA do MESMO link — que só volta a carregar depois de o usuário
     * visitar outro módulo e retornar (esse caminho passa pelo setter de
     * currentModuleName e limpa o _activeFrame). Zerar o estado aqui faz a
     * reabertura seguir exatamente o mesmo caminho (bom) da troca de módulos.
     */
    resetActiveModule() {
        this._activeFrame = undefined
        this.#currentModuleName = ""
    }

    async internalLoad({ frame, routeKey, route, vars, noActivate, originFrame }: { frame: IMillenniumFrame | undefined; routeKey: string; route?: IRoute | string; vars?: any; noActivate?: boolean; originFrame?: IMillenniumFrame }): Promise<any> {
        try {
            try {

                let params: any
                let url = ""
                if ((typeof route === "object" && (route.target || route.urlKey))) {//the route came ready from the host, like in embeded use case
                    params = route
                    routeKey = routeKey || route?.target || route?.urlKey || ""
                    // Mantém a URL sincronizada com a rota aberta também quando ela chega PRONTA
                    // (menu/startup passam o objeto com target). O valor vai para o href do link da
                    // aba (setUrl) e o `activateTab` o publica com history.pushState. Sem isso o href
                    // fica "" e o pushState grava a URL SEM o fragmento — o reload seguinte perde a
                    // rota e cai na home. Usa a CHAVE da rota (resolvível no startup), não o target.
                    const routeUrlKey = ((route as any).urlKey || (route as any).key ||
                        (routeKey.indexOf(".") < 0 ? routeKey : "")).toString()
                    if (routeUrlKey)
                        url = window.location.pathname + "#/" + routeUrlKey.toLowerCase() + ((vars instanceof Object) ? "/" + JSON.stringify(vars) : "")
                } else {//here we just have the key, need to load route details
                    url = window.location.pathname + "#/" + (routeKey || (typeof route === "string" ? route : undefined) || "").toLowerCase() + ((vars instanceof Object) ? "/" + JSON.stringify(vars) : "")
                    params = await this.decodeRoute(routeKey, route, vars)
                }

                // target2 (dual-target): decisão GLOBAL do admin, baixada 1×/sessão (ensureExpSet).
                // Se o id da tela está marcado p/ a versão nova, abre o target2; senão o clássico.
                if (params && params.target2) {
                    const expId = String(routeKey || params.id || params.key || params.urlKey || "")
                    if (expId && (await this.ensureExpSet()).has(expId.toUpperCase()))
                        params = { ...params, target: params.target2 }
                }

                let frameLocation = ""

                var moduleName = params.target

                if (!moduleName) return

                if (moduleName.indexOf(",") > 0)
                    [frameLocation, moduleName] = moduleName.split(",")
                if (moduleName.substr(-5).toLowerCase() === ".html")
                    moduleName = moduleName.slice(0, -5)
                if (moduleName.charAt(0) === '#')
                    moduleName = moduleName.slice(1)

                const originatingFrame = originFrame ?? frame;
                if ((frameLocation === "_blank" || !frame) && frame?.element.childElementCount !== 0) {
                    frame = this.frame_create()
                    // Aba originada de outra aba: insere logo após a aba ativa (em vez de ir ao final)
                    if (originatingFrame && frame !== originatingFrame
                        && originatingFrame instanceof MillenniumFrame
                        && frame instanceof MillenniumFrame) {
                        frame.insertTabsAfter(originatingFrame);
                    }
                }
                //module loader
                frame.element.setAttribute("id", params.target)

                const validKeys = ["caption"]
                const paramCaption = (params?.params as any[])?.find(e => validKeys.indexOf(e["@type"]) !== -1)
                let rawCaption = params?.caption || params?.text || paramCaption?.caption || ""
                // Fallback do título quando a rota chega sem caption/text (ex.: URL "#/rota" digitada
                // ou startup cru sem metadados): deriva do texto do menu (`_routes`), que é o que a
                // sidebar renderiza. No embedded (binbrowser) o caption normalmente já vem embutido
                // na URL pelo nativo (TargetURL anexa o JSON do EncodeJsLink — inclusive para links
                // simples "#target"); este fallback só cobre o modo browser, onde `_routes` existe.
                if (!rawCaption)
                    rawCaption = this.captionFromMenu(routeKey || params?.target || params?.urlKey || "")
                // Caption pode vir codificado como "Grupo|Label" para agrupamento na barra de comandos.
                // Para o título da aba só interessa o label.
                const sep = rawCaption.search(/[|\\]/)
                const caption = sep > 0 ? rawCaption.slice(sep + 1).trim() : rawCaption
                frame.setCaption(caption)
                frame.setUrl(url)
                frame.moduleName = this.#currentModuleName
                frame.key = routeKey
                frame.route = params

                let { moduleClass, htmlTemplate, cssTemplate } = await loadModule(moduleName)

                if (cssTemplate && typeof cssTemplate !== "object") {
                    let tmpStyle = document.createElement("div")
                    tmpStyle.innerHTML = "<style>" + cssTemplate.replace(/\n/g, '') + "</style>"
                    const finalized = tmpStyle.querySelector(".css-finalized")
                    if (finalized)
                        htmlTemplate = "<style>" + cssTemplate + finalized.textContent + "</style>" + htmlTemplate
                }

                const targetClass = moduleClass.default || moduleClass
                var module: any

                try {
                    if (typeof targetClass.mlnCreate === 'function') {
                        // mlnCreate is fully responsible for initialization
                        module = await targetClass.mlnCreate(frame, params)
                        // Guard: onInit pode ter chamado frame.close() (ex.: paginas redirect-only
                        // como pos.negotiation que so navegam para outra rota). Nesse caso o
                        // frame.element ja foi desconectado e nao tem mais parentNode — pular
                        // o replaceElement evita "Cannot read properties of null (reading
                        // 'replaceChild')".
                        if (module instanceof HTMLElement && frame.element.parentNode)
                            (frame as MillenniumFrame).replaceElement(module)
                    } else {
                        // Plain class fallback: loader handles template and lifecycle
                        module = new targetClass()
                        if (!module.bind) {
                            frame.element.innerHTML = htmlTemplate
                            if (module.onInit)
                                await module.onInit(frame, params)
                        } else {
                            await module.bind(frame, params, htmlTemplate)
                        }
                    }

                    // Associate frame after creation — replaceElement may have changed frame.element
                    ; (frame.element as any)[mlnFrameInstanceSymbol] = frame

                } catch (e: any) {
                    this.notify("Erro carregando módulo: " + ((e instanceof Error) ? e.message : e.toString()), "danger")
                    if (e instanceof Error) console.error(e.message, e.stack)
                    return
                }

                (frame.element as any)[mlnModuleInstanceSymbol] = module

                if (!noActivate) {
                    await frame.activate()
                } else {
                    // Carregado em background — remove o "active" default do tab/nav
                    // (MillenniumFrame constructor marca com active; sem activate() isso cria
                    //  highlight espúrio em paralelo ao tab realmente ativo)
                    const frameSheet = frame.element
                    this.querySelectorAll<HTMLElement>("#header ul li, #header-left ul li").forEach(t => {
                        if ((t as any)[mlnTabSheetSymbol] === frameSheet)
                            t.classList.remove("active")
                    })
                }
                window.dispatchEvent(new Event("resize"))

                frame.element.classList.add("activated")

                //only ok after session joint
                this.frame_activate(frame)

                // Onboarding contextual: dispara UMA vez por abertura de tela, com o
                // DOM já montado e frame.key = screen ID. Fire-and-forget — nunca
                // bloqueia nem lança para o caminho de load.
                if (!noActivate) {
                    // No desktop (embedded) o binbrowser controla o onboarding pelo seu menu,
                    // via a prop injetada millennium.browser.onboardingEnabled — aplicada a cada
                    // ativação para o toggle valer já na próxima tela. Não toca o globalDisabled
                    // (preferência do menu do avatar, oculto no desktop).
                    if (this.isEmbedded)
                        Onboarding.enabled = !this.offlineMode && (millennium.browser.onboardingEnabled !== false)
                    Onboarding.onFrameActivated(frame)
                    Feedback.trackScreen(frame)
                }
            } finally {
                if (this.afterLoad)
                    this.afterLoad()
            }
        } catch (error: any) {
            this.notify(error, "danger")
            frame?.close()
        }
    }

    get userName(): string {
        return this.session.userName
    }
    get userGroup(): string {
        return this.session.userGroup
    }
    get wsid(): string {
        return this.session.wsid
    }

    async joinSession(host: string, sessionId: string, sessionData: any, joinOnServer: boolean, appName?: string) {
        try {
            await this.session.joinSession(host, sessionId, sessionData, joinOnServer, appName)
            this.loginDone()
        } catch (e) {
            if (this.onLoginDone)
                this.onLoginDone.trigger()
            throw e
        }
    }

    loginError() {
        this.notify("Não autenticado", "danger")
    }
    getData(dataType: string, callback: (data: string) => void) {
        callback('')
    }
    private handleWindowMessage = (e: MessageEvent) => {
        if (e.origin !== location.origin) return
        this.broadcastRecv(e.data.name, e.data.data)
    }
    private _subscriptions = new Map<string, { callbacks: any[], id: number }>();
    broadcastRecv = (subject: string, data: string) => {
        const subs = this._subscriptions.get(subject)
        if (subs)
            for (const sub of subs.callbacks)
                sub(JSON.parse(data))
    }
    broadcast(name: string, data: any) {
        window.postMessage({ name, data: JSON.stringify(data) }, location.origin)
    }
    subscribeRemove(subject: string, callback: (data: any) => void) {
        let subs = this._subscriptions.get(subject.toUpperCase())
        if (subs) {
            const idx = subs.callbacks.findIndex(e => e === callback)
            if (idx >= 0) subs.callbacks.splice(idx, 1)
            if (subs.callbacks.length === 0) {
                this.win_subscribeRemove(subject, subs.id)
                this._subscriptions.delete(subject)
            }
        }
    }
    subscribeAdd(subject: string, callback: (data: any) => void) {
        let subs = this._subscriptions.get(subject.toUpperCase())
        if (!subs) {
            const subHandle = this.win_subscribeAdd(subject.toUpperCase(), this.broadcastRecv)
            subs = { callbacks: [], id: subHandle }
            this._subscriptions.set(subject, subs)
        }
        subs.callbacks.push(callback)
    }
    private win_subscribeAdd(subject: string, callback: (subject: string, data: any) => void): number {
        return -1
    }
    private win_subscribeRemove(subject: string, handle: number) {
    }
    initialize() {
    }
    printPDF(pdfAsBlob: Blob): void {
        var blobPdf = new Blob([pdfAsBlob], { type: 'application/pdf' })
        var blobURL = URL.createObjectURL(blobPdf)

        const iframe = document.createElement('iframe')
        document.body.appendChild(iframe)

        iframe.style.display = 'none'
        iframe.src = blobURL
        iframe.onload = function () {
            setTimeout(function () {
                iframe.focus()
                iframe.contentWindow?.print()
            }, 1)
        }
    }
    savePDF(pdfAsBlob: Blob): void {
        const blob = new Blob([pdfAsBlob], { type: "application/pdf" })
        const link = document.createElement("a")
        const href = window.URL.createObjectURL(blob)

        link.download = `${new Date().getTime()}.pdf`
        link.href = href
        link.click()
    }
    saveFile(fileAsBlob: Blob, aType: string, fileName: string): void {
        const blob = new Blob([fileAsBlob], { type: aType })
        const link = document.createElement("a")
        const href = window.URL.createObjectURL(blob)

        link.download = fileName
        link.href = href
        link.click()
    }

    async loadExtension(name: string) {
        return loadExtension(name + (!name.startsWith("http") && !name.endsWith(".mjs") ? ".js" : ""))
    }

    createModal(content: HTMLElement, options: IModalWindowOptions): IModalWindow {
        const dialog = new CommandDialogWindow()
        return {
            close: (result) => dialog.close(result),
            show: () => dialog.show(content, options)
        }
    }
    destroy() {
        window.removeEventListener("message", this.handleWindowMessage)
    }
    createNativeFrame(): Promise<number> {
        throw Error("not implemented")
    };
    resizeNativeFrame(frameHandle: number, left: number, top: number, width: number, height: number, visible: number): void {
        throw Error("not implemented")
    };
    navigateNativeFrame(frameHandle: number, place: string): void {
        throw Error("not implemented")
    };
    destroyNativeFrame(frameHandle: number): void {
        throw Error("not implemented")
    };

    private notifiersList: (INotificationSource & { currentCount: number, currentList: INotificationItem[] })[] = []
    private keepAliveInterval: any
    private _routes: IRoute[] = []
    private _navTree?: MlnTreeView
    private _favoritesUnsubscribe?: () => void
    private _moduleRoutes: IRoute[] = []
    private _startupUrl: string = ""
    /** @see IMillenniumBrowser.startupRoute — rota inicial injetada por um shell dedicado antes do start(). */
    public startupRoute?: IRoute
    private activeSubmenu: Menu | undefined
    private currentLoginCallback: ((host: string, userName: string, password: string) => Promise<void>) | undefined
    private _searchTimeout: any

    connectedCallback() {
        if (this.childElementCount === 0) {
            this.innerHTML = browserHtmlTemplate
            this.start()
        }
        if (!this._visibilityListenerAttached) {
            this._visibilityListenerAttached = true
            document.addEventListener("visibilitychange", this.handleVisibilityChange)
        }
    }

    private _visibilityListenerAttached = false
    private handleVisibilityChange = () => {
        const frame = this._activeFrame
        if (!frame) return
        const visible = document.visibilityState === "visible"
        const module = (frame.element as any)[mlnModuleInstanceSymbol]
        if (module && typeof module.setActive === "function") {
            try { module.setActive(visible) } catch (e) { console.error(e) }
        }
    }

    private handleSidebarMouseDown(e: Event) {
        const sidebar = this.querySelector('#sidebar')
        if (sidebar && !sidebar.contains(e.target as Node)) {
            this.hideSideBar()
        }
    }

    private showSideBar() {
        const sidebar = this.querySelector<HTMLElement>('#sidebar')
        if (sidebar) {
            sidebar.style.display = "flex"
            setTimeout(() => {
                if (sidebar)
                    sidebar.style.transform = "translateX(0)"
                const searchBox = this.querySelector<HTMLInputElement>('#sidebar .search-box')
                if (searchBox && !Capacitor.isNativePlatform())
                    searchBox.focus()
            }, 50)
        }
        const dimmer = this.querySelector<HTMLElement>('.dimmer')
        if (dimmer)
            dimmer.classList.add('dimmer-show')
        window.addEventListener("mousedown", (e) => this.handleSidebarMouseDown(e))
        window.addEventListener("touchstart", (e) => this.handleSidebarMouseDown(e))
    }

    private hideSideBar(callback?: () => void) {
        window.removeEventListener("mousedown", this.handleSidebarMouseDown)
        window.removeEventListener("touchstart", this.handleSidebarMouseDown)
        const dimmer = this.querySelector<HTMLElement>('.dimmer')
        if (dimmer && dimmer.classList.contains("dimmer-show")) {
            const sidebar = this.querySelector<HTMLElement>('#sidebar')
            if (sidebar) {
                sidebar.style.transform = "translateX(-102%)"
                if (callback) {
                    sidebar.addEventListener("transitionend", function (e) {
                        if (callback && typeof callback === "function") callback()
                        callback = undefined
                    }, { once: true })
                }
            }
            dimmer.classList.remove('dimmer-show')
        }
    }

    private adjustPreloader() {
        const preloader = this.querySelector<HTMLElement>('#preloader')
        if (preloader && preloader.style.display !== "none") {
            preloader.style.marginLeft = `${((window.innerWidth ?? 0) - (preloader.offsetWidth ?? 0)) / 2}px`
            preloader.style.marginTop = `${((window.innerHeight ?? 0) - (preloader.offsetHeight ?? 0)) / 2}px`
        }
    }

    private showPreloader(value: boolean) {
        const dimmer = this.querySelector<HTMLElement>('.dimmer')
        const preloader = this.querySelector<HTMLElement>('#preloader')
        if (value) {
            if (dimmer)
                dimmer.classList.add('dimmer-show')
            if (preloader) {
                preloader.classList.add("windows8")
                preloader.style.display = "block"
                this.adjustPreloader()
            }
        }
        else {
            if (dimmer)
                dimmer.classList.remove('dimmer-show')
            if (preloader) {
                preloader.style.display = "none"
                preloader.classList.remove("windows8")
            }
        }
    }

    private updateNotificationCount(notifier: INotificationSource & { currentCount?: number, currentList?: INotificationItem[] }, result: INotificationItem[]) {

        for (const item of result) {
            const found = notifier.currentList && notifier.currentList.find(e => e.key === item.key)
            if (!found) {
                this.notify(item.description, "warning")
            }
        }

        notifier.currentList = result
        notifier.currentCount = result.reduce((count, next) => count + 1, 0)

        const el = document.getElementById("notification_count")
        if (el) el.textContent = this.notifiersList.reduce((sum, next) => sum + next.currentCount, 0).toString()

        localStorage.setItem("last-notify-" + notifier.name, JSON.stringify(result))
    }

    private async startNotifications() {
        const notifiers = await loadNotifiers()
        for (const notifier of notifiers) {
            type INotificationSourceEx = INotificationSource & {
                currentCount: number
                currentList: INotificationItem[]
            }

            const instance = notifier.Notifier as INotificationSourceEx

            const curListJSON = localStorage.getItem("last-notify-" + instance.name)
            if (curListJSON) instance.currentList = JSON.parse(curListJSON)
            this.notifiersList.push(instance)

            instance.subscribe((result) => this.updateNotificationCount(instance, (result as INotificationSourceEx).currentList))
        }
    }

    private keepAlive() {
        // Double duty: (1) detecta a disponibilidade do broker via ping de alcance robusto a
        // 401/404 (checkNow → atualiza Client.onLine + dispara onlineChange); (2) quando online,
        // o GET renova a sessão no servidor — propósito original do heartbeat. Reagenda sempre,
        // com cadência adaptativa (curta enquanto offline/em transição, longa quando estável).
        this.wireOnlineFanout()
        void this._connectivity.checkNow()
            .then(online => { if (online) void Client.get("wtssystem/system/now") })
            .catch(() => { /* checkNow não rejeita; guard defensivo */ })
            .finally(() => this.scheduleKeepAlive())
    }

    private scheduleKeepAlive() {
        clearTimeout(this.keepAliveInterval)
        const fast = !this._connectivity.available || this._connectivity.isTransitioning
        // Online estável: 2–3 min (baixo custo, mantém sessão). Offline/transição: 15 s (detecção rápida).
        const delay = fast ? 15000 : 60000 * 2 + Math.round(Math.random() * 60000)
        this.keepAliveInterval = setTimeout(() => this.keepAlive(), delay)
    }

    private async handleMenuItemClick(event: Event) {
        if (!(event.target instanceof HTMLElement)) return

        if (event.target.classList.contains("menu-item_active")) {
            event.stopImmediatePropagation()
            event.preventDefault()
            return
        }

        event.target.classList.add("menu-item_active")

        this.activeSubmenu?.close() //we can´t await so the activeSubmenu don´t get overriten by another event
        this.activeSubmenu = new Menu()
        const route = await this.activeSubmenu.show<IRoute | undefined | number>(event.target, (event.target as any)["MENU_ITEMS"] ?? [])
        event.target.classList.remove("menu-item_active")

        if (route && typeof route === "object")
            this.loadRoute(route)
    }

    _menuDebounceTimer: any
    private showMenu(moduleName: string, routes: IRoute[]) {
        const menuBar = this.querySelector<HTMLElement>(".menu-bar")
        if (!menuBar) return
        menuBar.innerHTML = ""

        if (!this._routes.find(e => e.nodes?.length)) {
            menuBar.hidden = true
            return
        }
        menuBar.hidden = false

        const createMenuItem = (text: string, nodes: IRoute[] = []) => {
            const item = document.createElement("div") as HTMLElement & { ["MENU_ITEMS"]?: IRoute[] }
            item.innerText = text
            item.className = "menu-item"
            item.onpointerdown = (e) => this.handleMenuItemClick(e)
            item.onpointerleave = (e) => {
                if (this._menuDebounceTimer) {
                    clearTimeout(this._menuDebounceTimer)
                    this._menuDebounceTimer = undefined
                }
            }
            item.onmouseenter = (e) => {
                if (this._menuDebounceTimer) {
                    clearTimeout(this._menuDebounceTimer)
                    this._menuDebounceTimer = undefined
                }
                this._menuDebounceTimer = setTimeout(() => {
                    this._menuDebounceTimer = undefined
                    this.handleMenuItemClick(e)
                }, 200)
            }
            item["MENU_ITEMS"] = nodes
            return item
        }

        let mainMenu: HTMLElement & { ["MENU_ITEMS"]?: IRoute[] } | undefined
        for (const route of routes) {
            if (route.nodes?.length) {
                const item = createMenuItem(route.text, route.nodes)
                menuBar.appendChild(item)
            } else {
                if (!mainMenu) {
                    mainMenu = createMenuItem(moduleName || "Geral")

                    if (menuBar.firstElementChild)
                        menuBar.firstElementChild.insertAdjacentElement("beforebegin", mainMenu)
                    else
                        menuBar.appendChild(mainMenu)
                }
                mainMenu["MENU_ITEMS"]?.push(route)
            }
        }
    }

    private async showModule(moduleName: string, targetFrame?: IMillenniumFrame, backgroundHome = false) {

        if (this.currentModuleName === moduleName) return

        if (this._activeFrame && this._activeFrame.moduleName !== moduleName) {
            try { this._activeFrame.deactivate() } catch (e) { console.error(e) }
            this._activeFrame = undefined
        }

        const menuPanel = this.querySelector(".side-module-selector")

        this.updateWorkspaceIndicators()
        if (menuPanel)
            menuPanel.querySelectorAll(".menu-side-item").forEach(e => {
                if (e.getAttribute("data-menu") === moduleName)
                    e.classList.add("active")
                else
                    e.classList.remove("active")
            })

        const allWorkspaceItems = (this._routes.find(e => e.text === moduleName)?.nodes ?? []).filter(e => e?.text)
        const workspaceMenuItems = allWorkspaceItems.filter(e => !e.nodes?.length) // itens que vão pro mainMenu
        const generalItems = this._routes.filter(e => e.nodes === undefined && e?.text)

        // Combina itens do workspace com itens gerais, adicionando separador se ambos existirem
        this._moduleRoutes = [
            ...allWorkspaceItems,
            ...(workspaceMenuItems.length && generalItems.length ? [{ text: "-" } as IRoute] : []),
            ...generalItems
        ]
        this.showMenu(moduleName, this._moduleRoutes)
        this.currentModuleName = moduleName
        // Home virtual (moduleName === "") é tratada por openHomeFrame — não auto-carregar rota aqui
        if (!moduleName) return undefined
        const override = this._workspacesConfig.get(moduleName)
        const homeKey = override?.homeKey?.toLowerCase()
        const findDeep = (items: IRoute[], predicate: (r: IRoute) => boolean): IRoute | undefined => {
            for (const it of items) {
                if (it && predicate(it)) return it
                if (it?.nodes?.length) {
                    const found = findDeep(it.nodes, predicate)
                    if (found) return found
                }
            }
            return undefined
        }
        const homeRoute =
            (homeKey && findDeep(this._moduleRoutes, e =>
                (e.urlKey || e.key || "").toLowerCase() === homeKey)) ||
            this._moduleRoutes.find(e => e.text?.indexOf("Portal") > -1)
        if (homeRoute && homeRoute.key && !this.hasFrame(homeRoute.key))
            await this.loadRoute(homeRoute, targetFrame, backgroundHome)

        return homeRoute
    }

    private handleSidePanelClick(e: Event) {
        if (!e.target || !(e.target instanceof HTMLElement)) return
        const moduleName = e.target.getAttribute("data-menu") ?? ""
        void (async () => {
            await this.showModule(moduleName)
            if (moduleName === "") await this.openHomeFrame()
        })()
    }

    private async openHomeFrame() {
        const tabs = this.querySelectorAll<HTMLElement>("#header ul li")
        for (const tab of Array.from(tabs)) {
            const sheet = (tab as any)[mlnTabSheetSymbol] as HTMLElement | undefined
            const frame = sheet ? ((sheet as any)[mlnFrameInstanceSymbol] as IMillenniumFrame | undefined) : undefined
            if (frame?.route?.target === "home") {
                const anchor = tab.querySelector<HTMLAnchorElement>("a")
                anchor?.click()
                return
            }
        }
        const curFrame = this.createFrame()
        await this.load(curFrame, "", { target: "home", caption: "Millennium", urlKey: "", text: "" }, null)
    }

    private buildModulePanel() {

        const moduleSelector = this.querySelector<HTMLElement>(".side-module-selector")
        if (moduleSelector) {
            moduleSelector.innerHTML = ""
            moduleSelector.style.display = ""
        }

        if (!this._routes.find(e => e.nodes?.length)) {
            if (moduleSelector)
                moduleSelector.style.display = "none"
            return
        }

        const createModuleItem = (route: IRoute | { text: string }, targetModule?: string, active = false) => {
            const item = document.createElement("button")
            item.title = route.text
            item.className = "menu-side-item"
            const icon = document.createElement("img")
            const override = this._workspacesConfig.get(route.text)
            const inferred = route.text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll(" ", "_") + ".svg"
            icon.src = "images/" + (override?.icon ?? inferred)
            icon.onerror = (e) => { checkShowPanel(); if (e instanceof Event && e.target instanceof HTMLImageElement && !e.target.src.endsWith("generic.svg")) e.target.src = "images/generic.svg" }
            icon.onload = (_) => { checkShowPanel() }
            item.appendChild(icon)
            const text = document.createElement("label")
            text.innerText = route.text
            item.onclick = (e) => this.handleSidePanelClick(e)
            item.setAttribute("data-menu", targetModule ?? route.text)
            item.appendChild(text)
            if (active) item.classList.add("active")
            return item
        }

        let itemCount = 1
        if (this._routes.length) {
            if (moduleSelector)
                moduleSelector.appendChild(createModuleItem({
                    text: "Home"
                }, "", true))
        }
        const workspaces = this._routes.filter(r => r.nodes?.length)
        const orderOf = (r: IRoute) => this._workspacesConfig.get(r.text)?.order ?? Number.POSITIVE_INFINITY
        const ordered = workspaces
            .map((r, idx) => ({ r, idx }))
            .sort((a, b) => {
                const d = orderOf(a.r) - orderOf(b.r)
                return d !== 0 ? d : a.idx - b.idx
            })
            .map(x => x.r)
        for (const route of ordered) {
            itemCount++
            if (moduleSelector)
                moduleSelector.appendChild(createModuleItem(route))
        }

        //show when all images are loaded
        const checkShowPanel = () => {
            itemCount--
            if (itemCount === 0)
                setTimeout(() => {
                    moduleSelector?.classList.add("side-module-selector_ready")
                    document.querySelector(".navbar-brand")?.classList.add("side-module-selector_ready")
                }, 50)
        }

        //or when there is a timeout
        setTimeout(() => moduleSelector?.classList.add("side-module-selector_ready"), 500)
    }

    private updateWorkspaceIndicators() {
        const moduleSelector = this.querySelector<HTMLElement>(".side-module-selector")
        if (!moduleSelector) return
        const counts = new Map<string, number>()
        for (const frame of this[FRAMES]) {
            const name = frame.moduleName
            if (!name) continue
            counts.set(name, (counts.get(name) ?? 0) + 1)
        }
        moduleSelector.querySelectorAll<HTMLElement>(".menu-side-item").forEach(btn => {
            const name = btn.getAttribute("data-menu") ?? ""
            btn.classList.toggle("has-tabs", !!name && (counts.get(name) ?? 0) > 0)
        })
    }

    /**
     * Chave estável por USUÁRIO para os stores locais (onboarding "já visto",
     * relógio do feedback). NÃO usa wsid: o localStorage já é por máquina, e tanto
     * userName quanto wsid mudam de formato entre login novo (loginData) e reuso de
     * sessão (sessionParts) — o que reiniciava o "já visto" a cada logoff+reload.
     * Normaliza tirando o domínio e em minúsculo: "DOMINIO\\gmhis" e "gmhis" → "gmhis".
     */
    private stableUserKey(): string {
        return (this.userName || "").trim().toLowerCase().replace(/^.*[\\/]/, "")
    }

    private _onboardingReady = false
    private initOnboarding() {
        // Identidade por usuário para o store local de "já visto" (chave estável;
        // troca de usuário na mesma máquina não vaza estado).
        Onboarding.setUser(this.stableUserKey(), this.userGroup)
        if (this._onboardingReady) return
        this._onboardingReady = true
        // Em contingência não há telas com onboarding remoto; mantém local desligado.
        Onboarding.enabled = !this.offlineMode
        // Catálogo do core carregado LAZY (uma vez por janela, cacheado). Servido
        // estaticamente de web-apps — sem chamada ao broker.
        Onboarding.useCatalog(async () => {
            try { return await Client.getJSON<OnboardingItem[]>("./millennium.onboarding.json") }
            catch { return [] }
        })

        // Feedback/rating + telemetria de navegação (envio em lote). Desligado em
        // contingência (sem broker) e no EMBEDDED (binbrowser): no cliente desktop a
        // telemetria é NATIVA (navlog), fonte única que também cobre as telas legadas
        // em DLL — que não passam por este shell. setUser sempre para chavear por usuário.
        Feedback.enabled = !this.offlineMode && !this.isEmbedded
        Feedback.init()
        Feedback.setUser(this.stableUserKey(), this.wsid)
    }

    private async loginSuccess() {
        this.initOnboarding()
        const loginDiv = this.querySelector<HTMLElement>("#login-div")
        if (loginDiv)
            loginDiv.blur()

        const navTreeContainer = this.querySelector<HTMLElement>('.sidebar .menu-tree-area')
        if (navTreeContainer)
            navTreeContainer.innerHTML = ""

        const licenceType = this.querySelector<HTMLSelectElement>("#licence_type")
        if (licenceType)
            licenceType.disabled = true

        if (!this.isEmbedded) {
            try {
                const versions = await this.getVersion()
                const versionOmni = this.querySelector(".versionOmnichannel")
                if (versionOmni)
                    versionOmni.textContent = versions["omni"] ?? ""
                const versionMillennium = this.querySelector(".versionMillennium")
                if (versionMillennium)
                    versionMillennium.textContent = versions["millennium"] ?? ""
            } catch { }

            const [routes] = await Promise.all([this.getRoutes(), this.loadWorkspacesConfig()])
            this._routes = routes
            const sidebar = this.querySelector<HTMLElement>('#sidebar')
            if (sidebar)
                sidebar.style.display = "none"

            this.buildModulePanel()

            const favItems = await favoritesService.load().catch(() => [] as FavoriteItem[])
            const favNode = this.buildFavoritesNode(favItems)
            this._routes.unshift(favNode)

            this._favoritesUnsubscribe?.()
            this._favoritesUnsubscribe = favoritesService.onChange(items => this.refreshFavoritesNode(items))

            const prevFrameActivate = this.frame_activate
            this.frame_activate = (frame: IMillenniumFrame) => {
                prevFrameActivate(frame)
                this.updateFavoriteToggleState()
                this.updateWorkspaceIndicators()
            }
            const prevFrameClose = this.frame_close
            this.frame_close = (frame: IMillenniumFrame) => {
                prevFrameClose(frame)
                this.updateFavoriteToggleState()
                this.updateWorkspaceIndicators()
            }

            if (navTreeContainer) {
                const navTree = document.createElement("mln-treeview") as MlnTreeView;
                navTree.className = "menu-tree"
                navTree.onhoverColor = "rgba(255,255,255,0.3)"
                navTree.selectedBackColor = "var(--accent-color)"
                navTree.collapseIcon = "far fa-chevron-down"
                navTree.expandIcon = "far fa-chevron-right"
                navTree.levels = 1
                navTree.treeData = this._routes;
                navTree.addEventListener("nodeSelected", (e) => {
                    this.nodeSelected(e, (e as CustomEvent).detail.node);
                });
                navTreeContainer.appendChild(navTree);
                this._navTree = navTree
                this.setupFavoritesManageClickDelegate()

                // Ícones nos nós de 1º nível da treeview:
                //  - route.icon em formato fontawesome (ex: "far fa-star") → usa <i>
                //  - route com filhos → sem ícone (estrutura já fica clara via chevron)
                //  - demais (atalhos folha) → <img> do SVG do módulo, com fallback generic.svg
                const normalizeIconName = (s: string) => s.toLowerCase()
                    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, "_");
                const isFontawesomeIcon = (icon?: string) => !!icon && /\bfa[srlb]?\b/.test(icon);
                const injectMenuIcons = () => {
                    const allItems = Array.from(navTree.querySelectorAll<HTMLElement>(".list-group > .list-group-item"));
                    const rootItems = allItems.filter(li => !li.querySelector(".indent"));
                    rootItems.forEach((liEl, idx) => {
                        if (liEl.querySelector(".menu-module-icon, .menu-module-fa")) return;
                        const route = this._routes[idx];
                        if (!route?.text) return;

                        const expandEl = liEl.querySelector(".expand-collapse");
                        const insertBefore = expandEl?.nextSibling || liEl.firstChild;

                        if (isFontawesomeIcon(route.icon)) {
                            const iconEl = document.createElement("i");
                            iconEl.className = "menu-module-fa " + route.icon;
                            liEl.insertBefore(iconEl, insertBefore);
                            return;
                        }

                        if (!route.nodes?.length) return;

                        const override = this._workspacesConfig.get(route.text);
                        const iconName = override?.icon || normalizeIconName(route.text);
                        const img = document.createElement("img");
                        img.src = "images/" + iconName + ".svg";
                        img.className = "menu-module-icon";
                        img.onerror = () => {
                            if (img.src.endsWith("generic.svg")) img.remove();
                            else img.src = "images/generic.svg";
                        };
                        liEl.insertBefore(img, insertBefore);
                    });
                };
                injectMenuIcons();
                // bootstrap-treeview esvazia e re-renderiza o DOM após click.
                // MutationObserver re-injeta os ícones em qualquer re-render.
                new MutationObserver(() => injectMenuIcons())
                    .observe(navTree, { childList: true, subtree: true });
            }

            // Primeira checagem imediata (detecta offline já no boot de contingência) e, em
            // seguida, agendamento adaptativo — keepAlive() reagenda a si mesmo.
            clearTimeout(this.keepAliveInterval)
            this.keepAlive()

            if (loginDiv)
                loginDiv.remove()
        }

        this.showPreloader(false)
        this.hideLogin()

        try {
            if (this._startupUrl) {

                let routeKey = this._startupUrl

                let routeObj
                const paramsIdx = routeKey.indexOf("?")
                if (paramsIdx >= 0) {
                    try {
                        routeObj = JSON.parse(decodeURIComponent(routeKey.substr(paramsIdx + 1)))
                        routeKey = routeObj.target ?? routeKey.substr(0, paramsIdx)
                    } catch (e) {
                        console.warn("[FAV] failed to parse startup route JSON:", e)
                        routeKey = routeKey.substr(0, paramsIdx)
                    }
                }

                while (routeKey.charAt(0) === "#" || routeKey.charAt(0) === "/")
                    routeKey = routeKey.substring(1)

                // Reconstruct vars from URL format "#/routeKey/jsonVars" produced by internalLoad
                let startupVars: any
                if (!routeObj) {
                    const slashIdx = routeKey.indexOf("/")
                    if (slashIdx >= 0) {
                        try { startupVars = JSON.parse(decodeURIComponent(routeKey.substring(slashIdx + 1))) } catch { }
                        routeKey = routeKey.substring(0, slashIdx)
                    }
                }

                if (routeKey?.trim()) {
                    // "#/home" é o target INTERNO da tela inicial — não é rota de menu
                    // (findRoute) nem do broker (getRoute): não tem id nem .lin. Sem
                    // reconhecê-lo aqui, o F5 em "#/home" não acha target em ramo algum e
                    // o boot termina sem reabrir a home (e sem republicar a URL). Reabre a
                    // MESMA home do boot (mesmo IRoute do fallback initialRoute abaixo).
                    if (!routeObj && !startupVars && routeKey.toLowerCase() === "home")
                        routeObj = { target: "home", caption: "Millennium", urlKey: "", text: "" }
                    if (!routeObj) routeObj = this.findRoute(routeKey)?.route
                    // Rota ainda não resolvida localmente (ex.: `_routes` vazio no boot). Se routeKey
                    // não é um target direto "biblioteca.modulo" (sem ponto = urlKey de rota, ex.:
                    // "pos-sales" vindo do config.xml do Cordova), tenta resolver via broker — o MESMO
                    // caminho usado por qualquer navegação normal (decodeRoute → getRoute). Sem isso,
                    // um urlKey cru nunca vira um target válido e cai no fallback abaixo, que exige
                    // formato "biblioteca.modulo" (loadModule quebra com nomes sem ponto).
                    // Resolve TAMBÉM quando a rota local existe mas NÃO tem `target`: as rotas de
                    // cliente (millennium.routes!<app>.json, ex. POS-SALES do Omni) trazem só
                    // text/urlKey/icon — o target vem do broker. Sem isso, achar a rota local pulava
                    // o broker e nenhum ramo abaixo carregava: o boot terminava silenciosamente sem
                    // abrir nada (F5 em "#/pos-sales" não reabria o PDV).
                    if (!routeObj?.target && !startupVars && routeKey.indexOf(".") <= 0 && !this.offlineMode) {
                        try { routeObj = (await this.getRoute(routeKey)) ?? routeObj }
                        catch (e) { console.warn("[startup] rota não resolvida no broker:", routeKey, e) }
                    }
                    if (startupVars) {
                        this._startupUrl = ""
                        const curFrame = this.createFrame()
                        await this.load(curFrame, routeKey, routeObj, startupVars)
                    } else if (routeObj?.target) {
                        this._startupUrl = ""
                        const curFrame = this.createFrame()
                        await this.loadRoute(routeObj, curFrame)
                    } else if (routeKey.indexOf(".") > 0) {
                        // routeKey já é um target direto "biblioteca.modulo" (deep link/boot fixo,
                        // ex.: "#omni.pos.sales" no config.xml do Cordova) — não passa por rota.
                        this._startupUrl = ""
                        const curFrame = this.createFrame()
                        await this.load(curFrame, "", { target: "#" + routeKey, text: "", urlKey: routeKey })
                    }
                }

            } else if (this.querySelector("#header ul")!.children.length === 0) {
                const curFrame = this.createFrame()
                // Rota inicial: por padrão a "home" do core. Um shell dedicado (ex.: o bundle de
                // contingência do Omni) injeta `startupRoute` ANTES do start() para abrir a sua própria
                // página de entrada — o core permanece agnóstico de páginas de outras libs.
                const initialRoute: IRoute = this.startupRoute
                    ?? { target: "home", caption: "Millennium", urlKey: "", text: "" }
                await this.load(curFrame, "", initialRoute, null)
            }
        }
        catch (e) {
            console.error("Error loading startup URL " + this._startupUrl, e)
        }

        if (!this.isEmbedded) {
            setTimeout(() => this.notify("Login concluído", "success"), 0)
            // Notificações dependem do broker — desativadas em contingência (offline).
            if (!this.offlineMode)
                void this.startNotifications()
        }
    }

    private currentHost() {
        let host
        if (localStorage) host = localStorage.getItem('defaultHost')
        if (host && host.indexOf(":") === -1) host = "https://" + host
        return host || (window.location.protocol + "//" + window.location.hostname + ":" + window.location.port)
    }

    private async defaultFinishLogin(host: string, userName: string, password: string) {
        if (localStorage) {
            localStorage.setItem('userName', userName)
            localStorage.setItem('defaultHost', host)
            if (Capacitor.isNativePlatform()) localStorage.setItem("password", btoa(password))
        }
        if (!this.inLogin) {
            this.showPreloader(true)
            try {
                let appName = localStorage.getItem("appname") || "B5WIN32"
                let licenceName = localStorage.getItem("licencename") || "retag"

                const licenceEl = this.querySelector<HTMLSelectElement>("#licence_type")
                if (licenceEl && licenceEl.selectedIndex >= 0) {
                    licenceName = licenceEl.options[licenceEl.selectedIndex].value
                    appName = licenceName.toUpperCase()
                    if (licenceName === "loja" || licenceName === "retag")//legacy
                        appName = "B5WIN32"

                    localStorage.setItem("appname", appName)
                    localStorage.setItem("licencename", licenceName)
                }

                await this.loginWith2FA(appName, licenceName, userName, password)
                await this.loginSuccess()
            }
            catch (e: any) {
                this.showPreloader(false)
                throw e
            }
        }
    }

    private async loginWith2FA(appName: string, licenceName: string, userName: string, password: string) {
        let twoFactorCode = ""
        let lastInvalid = false
        // permite ate 4 tentativas (1 inicial sem code + 3 com code)
        for (let attempt = 0; attempt < 4; attempt++) {
            try {
                await this.login(appName, licenceName, this.currentHost(), userName, password, twoFactorCode)
                return
            } catch (e: any) {
                if (!isTwoFactorError(e)) throw e

                this.showPreloader(false)
                try {
                    if (e.twoFactorKind === "enroll") {
                        const code = await showEnroll2FA(userName, password)
                        if (!code) throw new Error("Configuracao do autenticador cancelada")
                        twoFactorCode = code
                    } else {
                        // 'required' ou 'invalid'
                        const msg = lastInvalid || e.twoFactorKind === "invalid"
                            ? "Codigo invalido. Tente novamente."
                            : undefined
                        const code = await showPrompt2FA(msg)
                        if (!code) throw new Error("Codigo do autenticador nao informado")
                        twoFactorCode = code
                        lastInvalid = e.twoFactorKind === "invalid"
                    }
                } finally {
                    this.showPreloader(true)
                }
            }
        }
        throw new Error("Falha na verificacao em duas etapas (excedido o numero de tentativas)")
    }

    private notificationButtonClick() {
        for (const n of this.notifiersList) n.action()
    }

    private async loginClick() {
        if (this.currentLoginCallback)
            try {
                const hostname = this.querySelector<HTMLInputElement>('#hostname')
                const username = this.querySelector<HTMLInputElement>("#username")
                const password = this.querySelector<HTMLInputElement>("#password")
                await this.currentLoginCallback(hostname?.value ?? "", username?.value ?? "", password?.value ?? "")
                this.currentLoginCallback = undefined
            } catch (e: any) {
                this.notify(e, "danger")
                throw e
            }
    }

    private currentFrame() {
        return (this.querySelector("#header ul .active") as any)?.mlnFrameInstance as IMillenniumFrame
    }

    private async loadRoute(route: IRoute, frame?: IMillenniumFrame, noActivate?: boolean) {
        const routeObj = route.key && this.findRoute(route.key)
        if (routeObj) {
            const workspaceName = routeObj.path[0]?.text ?? ""
            const override = this._workspacesConfig.get(workspaceName)
            const homeKey = override?.homeKey?.toLowerCase()
            // Se a rota pedida NÃO é a home do workspace, carrega a home em background
            // (evita flicker de ativar a home antes da aba final)
            const routeKeyLc = route.key?.toLowerCase()
            const routeIsHome = (!!homeKey && routeKeyLc === homeKey) ||
                (!homeKey && (route.text?.indexOf("Portal") ?? -1) > -1)
            const moduleInfo = await this.showModule(workspaceName, frame, !routeIsHome)
            if (moduleInfo?.key === route.key) return
        }

        return this.load(frame ?? this.currentFrame(), route.key ?? "", route.target ? route : undefined, undefined, noActivate)
    }

    private nodeSelected(args: any, node: IRoute & { _client?: boolean, _favoriteItem?: FavoriteItem, _favoritesRoot?: boolean }) {
        if (node._favoritesRoot) return
        if (node._favoriteItem) {
            const key = this.extractRouteKeyFromFavorite(node._favoriteItem)
            if (key) {
                const real = this.findRouteInMenu(key)
                if (real) {
                    this.hideSideBar(() => this.loadRoute(real.route))
                    return
                }
            }
        }
        this.hideSideBar(() => this.loadRoute(node))
    }

    public isFavoriteNavigableInHtml(item: FavoriteItem): boolean {
        const key = this.extractRouteKeyFromFavorite(item)
        return !!key && !!this.findRouteInMenu(key)
    }

    public openFavorite(item: FavoriteItem): boolean {
        const key = this.extractRouteKeyFromFavorite(item)
        if (!key) return false
        const real = this.findRouteInMenu(key)
        if (!real) return false
        void this.loadRoute(real.route)
        return true
    }

    private extractRouteKeyFromFavorite(item: FavoriteItem): string {
        if (item.sourceId) return item.sourceId
        if (!item.sourceLink) return ""

        const parts = this.parseLocationInfoParts(item.sourceLink)
        if (parts.length >= 1 && parts[0]) return parts[0]

        return item.sourceLink
    }

    private parseLocationInfoParts(str: string): string[] {
        const parts: string[] = []
        let depth = 0, start = -1
        for (let x = 0; x < str.length && parts.length < 3; x++) {
            if (str[x] === "{") { if (depth === 0) start = x; depth++ }
            if (str[x] === "}") depth--
            if (depth === 0 && start >= 0) {
                parts.push(str.substring(start + 1, x))
                start = -1
            }
        }
        return parts
    }

    private findRouteInMenu(key: string): { route: IRoute, path: IRoute[] } | undefined {
        function findNode(children: IRoute[] | undefined): { route: IRoute, path: IRoute[] } | undefined {
            if (children)
                for (let x = 0; x < children.length; x++) {
                    if ((children[x] as any)._favoritesRoot) continue
                    if (children[x].nodes && children[x].nodes?.length) {
                        const node = findNode(children[x].nodes)
                        if (node) {
                            node.path.unshift(children[x])
                            return node
                        }
                    }
                    else if (children[x].key?.localeCompare(key, undefined, { sensitivity: 'accent' }) === 0) {
                        return { route: children[x], path: [] }
                    }
                }
        }
        return findNode(this._routes)
    }

    private buildFavoritesNode(items: FavoriteItem[]): IRoute & { _favoritesRoot: boolean } {
        return {
            text: 'Favoritos <button class="fav-manage-btn" title="Gerenciar favoritos" style="background:none;border:none;cursor:pointer;color:inherit;padding:0 4px;margin-left:auto;opacity:0.6;float:right"><i class="fa fa-cog"></i></button>',
            caption: "Favoritos",
            target: "",
            urlKey: "",
            icon: "far fa-star",
            nodes: this.buildFavoritesChildren(items),
            _favoritesRoot: true,
        } as any
    }

    private buildFavoritesChildren(items: FavoriteItem[]): IRoute[] {
        type FolderMap = { [name: string]: { route: IRoute & { nodes: IRoute[] }, children: FolderMap } }
        const root: FolderMap = {}
        const rootOrder: (IRoute & { _favoriteItem?: FavoriteItem })[] = []

        for (const item of items) {
            const key = this.extractRouteKeyFromFavorite(item)
            if (!key || !this.findRouteInMenu(key)) continue

            const parts = item.displayPath.split("\\").filter(p => p.length > 0)
            if (parts.length === 0) continue

            if (parts.length === 1) {
                rootOrder.push({
                    text: parts[0],
                    caption: parts[0],
                    target: "",
                    urlKey: "",
                    icon: "far fa-star",
                    _favoriteItem: item,
                } as any)
                continue
            }

            let folderMap = root
            let parentChildren: IRoute[] | null = null
            let folderRoute: (IRoute & { nodes: IRoute[] }) | null = null

            for (let i = 0; i < parts.length - 1; i++) {
                const name = parts[i]
                if (!folderMap[name]) {
                    const newFolder: IRoute & { nodes: IRoute[] } = {
                        text: name,
                        caption: name,
                        target: "",
                        urlKey: "",
                        icon: "far fa-folder",
                        nodes: [],
                    } as any
                    folderMap[name] = { route: newFolder, children: {} }
                    if (folderRoute) folderRoute.nodes.push(newFolder)
                    else rootOrder.push(newFolder)
                }
                folderRoute = folderMap[name].route
                parentChildren = folderRoute.nodes
                folderMap = folderMap[name].children
            }

            const leafName = parts[parts.length - 1]
            const leaf: IRoute & { _favoriteItem?: FavoriteItem } = {
                text: leafName,
                caption: leafName,
                target: "",
                urlKey: "",
                icon: "far fa-star",
                _favoriteItem: item,
            } as any
            parentChildren?.push(leaf)
        }

        return rootOrder
    }

    private refreshFavoritesNode(items: FavoriteItem[]) {
        const rootIdx = this._routes.findIndex(r => (r as any)._favoritesRoot)
        if (rootIdx < 0) return
        const updated = this.buildFavoritesNode(items)
        this._routes[rootIdx] = updated
        if (this._navTree) {
            this._navTree.treeData = this._routes
        }
        this.updateFavoriteToggleState()
    }

    private setupFavoritesManageClickDelegate() {
        if (!this._navTree) return
        this._navTree.addEventListener("click", (e) => {
            if ((e.target as HTMLElement).closest(".fav-manage-btn")) {
                e.stopPropagation()
                this.openFavoritesManageDialog()
            }
        })
    }

    private currentFavoriteItem(): FavoriteItem | undefined {
        const frame = this._activeFrame
        if (!frame) return

        const key = ((frame.key as string) || "").trim()
        if (!key) return

        const caption = (frame.caption || frame.route?.caption || frame.route?.text || "").trim()

        const upKey = key.toUpperCase()
        let routeJson = ""
        if (frame.route) {
            try {
                routeJson = encodeURIComponent(JSON.stringify(frame.route))
            } catch (e) {
                console.warn("[FAV] route not serializable:", e)
            }
        }
        const hashLocation = "#" + key + (routeJson ? "?" + routeJson : "")
        const sourceLink = "/\r\n[{" + upKey + "}{dmMain}{" + hashLocation + "}]()"

        return {
            displayPath: caption || key,
            sourceProvider: "BinNavigator",
            sourceId: key,
            sourceLink: sourceLink,
            newWindow: false,
            shortcut: 0,
        }
    }

    private findFavoriteIndex(item: FavoriteItem): number {
        const items = favoritesService.items
        const itemKey = this.extractRouteKeyFromFavorite(item)
        if (!itemKey) return -1
        return items.findIndex(i => {
            const iKey = this.extractRouteKeyFromFavorite(i)
            return iKey === itemKey
        })
    }

    private async toggleCurrentFavorite() {
        const item = this.currentFavoriteItem()
        if (!item) {
            this.notify("Nenhuma tela ativa para adicionar aos favoritos", "warning")
            return
        }
        const idx = this.findFavoriteIndex(item)
        if (idx >= 0) {
            await favoritesService.removeAt(idx)
            this.notify("Favorito removido", "success")
        } else {
            await favoritesService.add(item)
            this.notify("Adicionado aos favoritos", "success")
        }
    }

    async openFavoritesManageDialog(): Promise<void> {
        this.hideSideBar()
        const { openFavoritesManageDialog } = await import(
            /* webpackChunkName: "favorites-dialog" */
            "./favorites.dialog"
        )
        await openFavoritesManageDialog()
    }

    private updateFavoriteToggleState() {
        const btn = this.querySelector<HTMLButtonElement>("#favorite_toggle_button")
        if (!btn) return
        const isHome = this._activeFrame?.route?.target === "home"
        btn.style.display = isHome ? "none" : ""
        if (isHome) return
        const item = this.currentFavoriteItem()
        const icon = btn.querySelector("i")
        const isFav = !!item && this.findFavoriteIndex(item) >= 0
        btn.disabled = !item
        btn.style.opacity = item ? "" : "0.4"
        if (icon) {
            icon.classList.toggle("far", !isFav)
            icon.classList.toggle("fas", isFav)
        }
        btn.title = !item ? "Sem tela ativa" : (isFav ? "Remover dos favoritos" : "Adicionar aos favoritos")
    }

    /**
     * Resolve o texto amigável (título de aba) de uma rota a partir da árvore de menu `_routes`,
     * casando por key/urlKey/target normalizados (sem "#"/"/" à frente, case-insensitive).
     * Fallback para rotas que chegam sem `text`/`caption` no MODO BROWSER (ex.: URL "#/rota"
     * digitada à mão) — `_routes` só é populado quando a sidebar HTML existe. No embedded o
     * menu é nativo (`_routes` vazio) e o caption vem embutido na URL pelo binbrowser.
     * Retorna "" se não encontrar.
     */
    private captionFromMenu(rawKey: string): string {
        const norm = (s?: string) => (s || "").replace(/^[#/]+/, "").toLowerCase()
        const wanted = norm(rawKey)
        if (!wanted) return ""
        let found = ""
        const walk = (nodes?: IRoute[]) => {
            if (!nodes || found) return
            for (const n of nodes) {
                if (found) return
                if (n.nodes?.length) walk(n.nodes)
                else if (norm(n.key) === wanted || norm((n as any).urlKey) === wanted || norm(n.target) === wanted)
                    found = n.text || ""
            }
        }
        walk(this._routes)
        return found
    }
    private findRoute(key: string): { route: IRoute, path: IRoute[] } | undefined {
        function findNode(children: IRoute[] | undefined): { route: IRoute, path: IRoute[] } | undefined {
            if (children)
                for (let x = 0; x < children.length; x++)
                    if (children[x].nodes && children[x].nodes?.length) {
                        const node = findNode(children[x].nodes)
                        if (node) {
                            node.path.unshift(children[x])
                            return node
                        }
                    }
                    else if (children[x].key?.localeCompare(key, undefined, { sensitivity: 'accent' }) === 0) {
                        return { route: children[x], path: [] }
                    }
        }
        return findNode(this._routes)
    }

    private hideLogin() {
        const loginDiv = this.querySelector<HTMLElement>("#login-div")
        if (loginDiv)
            loginDiv.style.display = "none"
        const contentFrame = this.querySelector<HTMLElement>("#content-frame")
        if (contentFrame)
            contentFrame.classList.add("visible")
        //we need to remove for safety and because of a (very) wird chrome behaviour that
        //starts triggering keydown events for all over the place
        const password = this.querySelector<HTMLInputElement>("#password")
        if (password)
            password.remove()
    }

    private handleLoginDone(session?: Session) {
        if (session)
            localStorage.setItem('sessionData', JSON.stringify(session.loginData))
        this.hideLogin()
    }

    private handleBlurHostname() {
        const hostInput = this.querySelector<HTMLInputElement>('#hostname')
        if (!hostInput) return

        localStorage.setItem('defaultHost', hostInput.value as string)
        const licenceEl = this.querySelector<HTMLSelectElement>("#licence_type")
        if (licenceEl) licenceEl.innerHTML = ""
        void this.loadLicenceTypes()
    }

    private async loadLicenceTypes() {
        const licenceEl = this.querySelector<HTMLSelectElement>("#licence_type")
        if (licenceEl && licenceEl.children.length > 0) return

        const unlicensedEl = this.querySelector<HTMLElement>("#login-unlicensed")
        const fieldsEl = this.querySelector<HTMLElement>("#login-fields")

        try {
            const curName = Capacitor.isNativePlatform() ? "omni" : localStorage.getItem("licencename") || "omni"
            const result = await Client.get<any>("millenium:wtssystem.users.GetLicenceGroups", {}, { anonymous: true, licenceType: "mgt" })

            if (unlicensedEl) unlicensedEl.style.display = "none"
            if (fieldsEl) fieldsEl.style.display = ""

            for (const item of result.value) {
                const option = document.createElement("option")
                option.textContent = item.DESCRIPTION
                option.value = item.NAME
                option.setAttribute("data-type", item.TYPE)
                option.selected = curName === item.NAME
                option.style.background = "var(--command-color)"
                option.style.color = "white"
                option.style.padding = "5px"
                if (licenceEl)
                    licenceEl.append(option)
            }
        } catch (e: any) {
            const serverErrorEl = this.querySelector<HTMLElement>("#login-server-error")
            const isUnlicensed = e?.status === 401 || (typeof e === "string" && /401|unauthorized/i.test(e))

            if (isUnlicensed) {
                if (unlicensedEl) unlicensedEl.style.display = ""
                if (serverErrorEl) serverErrorEl.style.display = "none"
            } else {
                if (serverErrorEl) serverErrorEl.style.display = ""
                if (unlicensedEl) unlicensedEl.style.display = "none"
            }
            if (fieldsEl) fieldsEl.style.display = "none"
        }
    }

    private showInitialLogin(blank = false, message = "", callback = (host: string, user: string, pass: string) => this.defaultFinishLogin(host, user, pass)) {
        if (this.currentLoginCallback) throw Error("Login already in progress")

        clearTimeout(this.keepAliveInterval)
        this.showPreloader(false)
        this.currentLoginCallback = callback
        const password = this.querySelector<HTMLInputElement>("#password")
        if (password)
            password.remove()
        //creates the pwd element
        const pwdGroup = this.querySelector<HTMLElement>("#pwd-group")
        if (pwdGroup)
            pwdGroup.innerHTML = `<input autocomplete="off" class="light-placeholder" id="password" type="password" placeholder="Senha" style="border:none;background:none;width:100%"/>`
        const loginMessage = this.querySelector<HTMLElement>("#login-message")
        if (loginMessage)
            loginMessage.textContent = message

        const contentFrame = this.querySelector<HTMLElement>("#content-frame")
        if (!blank && contentFrame)
            contentFrame.classList.remove("visible")

        const loginAnim = this.querySelector<HTMLElement>("#login_anim")
        if (loginAnim)
            loginAnim.classList.add("show-fadein")
        const loginDiv = this.querySelector<HTMLElement>("#login-div")
        if (loginDiv)
            loginDiv.style.display = "flex"

        const username = this.querySelector<HTMLInputElement>("#username")
        const hasUser = username && username.value !== ""

        if (localStorage) {
            const hostname = this.querySelector<HTMLInputElement>("#hostname")
            if (hostname)
                hostname.value = (blank) ? "" : localStorage.getItem("defaultHost") || ""
            if (username)
                username.value = (blank) ? "" : localStorage.getItem("userName") || ""
            const password = this.querySelector<HTMLInputElement>("#password")
            if (password)
                password.value = ""
        }

        if (!blank && hasUser) {
            if (username)
                username.readOnly = true
            const password = this.querySelector<HTMLInputElement>("#password")
            if (password)
                password.focus()
        } else {
            if (username) {
                username.readOnly = false
                username.focus()
            }
        }

        setTimeout(function () { loginAnim?.classList.remove("show-fadein") }, 1000)

        void this.loadLicenceTypes()
    }

    private async showUserOptions() {
        const menu = new Menu()
        const usrImg = this.querySelector<HTMLElement>("#usr-img")
        if (!usrImg) return

        const onbEnabled = Onboarding.isGlobalEnabled()
        const IDX_REVER = 2
        const IDX_TOGGLE = 3
        const IDX_LOGOUT = 5
        const result = await menu.show<number>(usrImg, [
            this.userName,
            "-",
            "Rever dicas de ajuda",
            onbEnabled ? "Desativar dicas de ajuda" : "Ativar dicas de ajuda",
            "-",
            "Logout"
        ])

        if (result === IDX_REVER) {
            Onboarding.reset()
            const frame = this._activeFrame
            if (frame) Onboarding.retrigger(frame)
            this.notify("Dicas reativadas — elas reaparecem ao abrir as telas.", "success")
        } else if (result === IDX_TOGGLE) {
            Onboarding.setGlobalEnabled(!onbEnabled)
            this.notify(onbEnabled ? "Dicas de ajuda desativadas." : "Dicas de ajuda ativadas.", "success")
        } else if (result === IDX_LOGOUT) {
            this.logout()
        }
    }

    private filterRoutes(text: string): IRoute[] {

        function search(nodes: IRoute[]) {
            const searchResult = { nodes: [] as IRoute[], hasLeaf: false }
            for (const node of nodes) {
                if (node.nodes && node.nodes.length) {
                    const nodeResult = search(node.nodes)
                    searchResult.hasLeaf = searchResult.hasLeaf || nodeResult.hasLeaf
                    if (nodeResult.hasLeaf)
                        searchResult.nodes.push({ ...node, nodes: nodeResult.nodes })
                }
                else if (node.text?.match(searchRegex)) {
                    searchResult.hasLeaf = true
                    searchResult.nodes.push(node)
                }
            }
            return searchResult
        }

        const searchRegex = new RegExp(text, "i")
        const result = search(this._routes)
        if (result.hasLeaf)
            return result.nodes
        else
            return []
    }

    private handleSidebarSearch(e: Event) {
        clearTimeout(this._searchTimeout)
        this._searchTimeout = setTimeout(() => {
            const navTree = this.querySelector<MlnTreeView>('.sidebar .menu-tree')
            if (navTree) {
                const value = (e.target as HTMLInputElement).value
                const filteredRoutes = this.filterRoutes(value)
                navTree.treeData = filteredRoutes
                navTree.levels = value ? 10 : 1
            }
        }, 50)
    }

    private setupUI() {

        if (this.offlineMode) {
            // Modo bundled/contingência: o header do shell (módulos, favoritos, notificações, login, usuário)
            // não funciona offline. Opção NÃO-DEFAULT de ocultá-lo — `offlineMode` já é não-default, então o
            // core online segue mostrando o header normalmente. A marca da contingência fica NA PÁGINA, não aqui.
            const moduleHeader = this.querySelector<HTMLElement>('.mln-module-header')
            if (moduleHeader)
                moduleHeader.style.display = "none"
        }
        else if (!((window as any)["millennium"] && (window as any)["millennium"].browser && (window as any)["millennium"].browser.isEmbedded)) {
            const moduleHeader = this.querySelector<HTMLElement>('.mln-module-header')
            if (moduleHeader)
                moduleHeader.style.display = "flex"
            const usrImg = this.querySelector<HTMLImageElement>('#usr-img')
            if (usrImg)
                usrImg.src = "https://www.gravatar.com/avatar?d=mm&s=28"
        }
        else {
            const moduleHeader = this.querySelector<HTMLElement>('.mln-module-header')
            if (moduleHeader)
                moduleHeader.style.display = "none"
        }

        if (Environment.isMobile)
            window.document.body.classList.add("mobile")

        if (this.isEmbedded)
            window.document.body.classList.add("mln-embedded")

        const menuBtn = this.querySelector<HTMLElement>('#menu-btn')
        if (menuBtn)
            menuBtn.onclick = (e) => {
                this.showSideBar()
                e.stopPropagation()
            }

        if (location.protocol === "file:" || Capacitor.isNativePlatform()) {
            const hostInput = this.querySelector<HTMLElement>('.mln-host-input')
            const inputEl = this.querySelector<HTMLInputElement>('#hostname')

            if (hostInput) hostInput.style.display = "block"

            if (inputEl) inputEl.onblur = () => this.handleBlurHostname()
        }

        const loginBtn = this.querySelector<HTMLElement>("#login")
        if (loginBtn)
            loginBtn.onclick = () => this.loginClick()

        const testeBtn = this.querySelector<HTMLElement>("#teste")
        if (testeBtn)
            testeBtn.onclick = () => {
                this.switchUser()
            }

        const usrImg = this.querySelector<HTMLElement>("#usr-img")
        if (usrImg)
            usrImg.onclick = () => this.showUserOptions()

        const logoutBtn = this.querySelector<HTMLElement>("#logout")
        if (logoutBtn)
            logoutBtn.onclick = () => this.logout()

        const loginDiv = this.querySelector<HTMLElement>("#login-div")
        if (loginDiv)
            loginDiv.onkeydown = (e) => {
                if (e.keyCode === 13) {
                    const loginBtn = this.querySelector<HTMLElement>("#login")
                    if (loginBtn)
                        loginBtn.click()
                }
            }

        const sidebarClose = this.querySelector<HTMLElement>("#sidebar-close")
        if (sidebarClose)
            sidebarClose.onclick = () => this.hideSideBar()
        const sidebarSearch = this.querySelector<HTMLInputElement>("#sidebar-search")
        if (sidebarSearch) {
            sidebarSearch.onkeyup = (e) => this.handleSidebarSearch(e);
            (sidebarSearch as any).onsearch = (e: any) => this.handleSidebarSearch(e)
        }

        const notificationButton = this.querySelector<HTMLElement>("#notification_button")
        if (notificationButton)
            notificationButton.onclick = () => this.notificationButtonClick()

        const feedbackButton = this.querySelector<HTMLElement>("#feedback_button")
        if (feedbackButton)
            feedbackButton.onclick = () => Feedback.promptForFrame(this._activeFrame)

        const favoriteToggle = this.querySelector<HTMLButtonElement>("#favorite_toggle_button")
        if (favoriteToggle)
            favoriteToggle.onclick = () => this.toggleCurrentFavorite()

        const headerTabs = this.querySelector<HTMLElement>("#header ul")
        if (headerTabs)
            headerTabs.addEventListener("click", () => setTimeout(() => this.updateFavoriteToggleState(), 0))

        function getErrorMessage(obj: unknown) {
            if (!obj) return
            const message = (obj instanceof Error ? obj.message : String(obj)) || ""
            if (message.substring(0, 5) === "show:")
                return message.substring(5)
        }

        window.addEventListener("message", this.handleWindowMessage)

        window.addEventListener("error", event => {
            const message = getErrorMessage(event.error)
            if (message)
                this.notify(message, "danger")
        })

        window.addEventListener("unhandledrejection", event => {
            const message = getErrorMessage(event.reason)
            if (message)
                this.notify(message, "danger")
        })

        document.addEventListener("touchstart", function () { }, false)
        document.addEventListener("contextmenu", function (e: Event) {
            e.preventDefault()
        }, false)

        this.onLoginDone.subscribe((session) => this.handleLoginDone(session))

        var authInProcess = false
        this.onAuthFail.subscribe(async (options) => {
            if (authInProcess) return

            authInProcess = true
            try {
                this.accessList.delete(this.session.id)
                this.accessListLoading.delete(this.session.id)
                this.removePersistentAccessList(this.session)
                localStorage.setItem('sessionData', '')
                const loginDiv = this.querySelector("#login-div")
                if (loginDiv)
                    loginDiv.classList.add("login-auth-fail")

                const password = localStorage.getItem("password")
                if (Capacitor.isNativePlatform() && password) {
                    await this.defaultFinishLogin(this.currentHost(), getDefaultSession().userName, atob(password))
                } else if (options && options.blank) {
                    const loginInfo = await showLogin(options)
                    if (loginInfo)
                        await this.defaultFinishLogin(this.currentHost(), loginInfo.username, loginInfo.password)
                } else if (!this.isEmbedded) {
                    do {
                        var loginInfo = await showLogin()
                        if (loginInfo)
                            try {
                                await this.defaultFinishLogin(this.currentHost(), loginInfo.username, loginInfo.password)
                            } catch (e: any) {
                                this.notify(e, "warning")
                                loginInfo = undefined
                            }
                    } while (!loginInfo)
                } else {
                    try {
                        const sessionId = await this.getSessionId()
                        const licenceType = sessionId.split('|')[4]
                        await this.joinSession(location.protocol + "//" + location.host, sessionId, {}, true, licenceType)
                    } catch (e) {
                        console.error(e)
                    }
                }
            } finally {
                authInProcess = false
            }
        })

        const mainBody = this.querySelector(".mln-mainbody")
        if (mainBody)
            mainBody.classList.add("mln-mainbody_ready")
    }

    private async startup(startupPage: string) {

        this.hideLogin()
        this._startupUrl = startupPage

        // Contingência (offline): sem broker no boot. Reaproveita a sessão persistida (sem
        // revalidar no servidor) quando existir e segue direto para loginSuccess, que usa rotas
        // locais estáticas e abre a página de contingência como tela inicial.
        if (this.offlineMode) {
            // Assume offline já no boot (o tool foi aberto porque o broker está fora); o heartbeat
            // confirma o retorno com a histerese normal antes de indicar "disponível".
            this._connectivity.assumeOffline()
            try {
                const raw = localStorage.getItem('sessionData')
                const data = raw && JSON.parse(raw)
                if (data)
                    await this.joinSession(this.currentHost(), data.session, data, false, localStorage.getItem("appname") || "")
            } catch { /* segue sem sessão persistida */ }
            await this.loginSuccess()
            return
        }

        const rawSessionData = localStorage.getItem('sessionData')
        let sessionData
        try {
            sessionData = rawSessionData && JSON.parse(rawSessionData)
        } catch {
            sessionData = ""
        }
        if (!this.isEmbedded) {
            if (!sessionData)
                this.showInitialLogin()
            else {
                this.showPreloader(true)
                try {
                    await this.joinSession(this.currentHost(),
                        sessionData.session,
                        sessionData,
                        true,
                        localStorage.getItem("appname") || "")

                    await this.loginSuccess()
                } catch {
                    this.showInitialLogin()
                }
            }
        } else {
            try {
                const sessionId = await this.getSessionId()
                await this.joinSession(location.protocol + "//" + location.host,
                    sessionId,
                    {},
                    true)
                await this.loginSuccess()
            } catch (e) {
                console.error(e)
            }
        }
    }

    private async update() {
        const { currentBundleId } = await LiveUpdate.ready()

        const text = await Client.getText(getCurrentHost() + "/dist.zip.upd", {}, { anonymous: true })
        const checksum = text.split("\n").find(l => l.startsWith("CheckSum"))?.split("=")[1] ?? null

        if (checksum && checksum !== currentBundleId) {
            await LiveUpdate.downloadBundle({
                url: getCurrentHost() + "/dist.zip",
                bundleId: checksum,
            })
            await LiveUpdate.setNextBundle({ bundleId: checksum })

            const shouldUpdate = await millennium.browser.msgBox(
                "Deseja reiniciar o aplicativo para aplicar a atualização agora?",
                "Atualização disponível.",
                MsgBoxFlags.MB_YESNO
            ) === MsgBoxResult.IDYES

            if (shouldUpdate) void LiveUpdate.reload()
        }
    }

    public start() {
        //wireup all events
        this.setupUI()
        void this.startup(location.hash)

        if (Capacitor.isNativePlatform()) {
            void this.update()
        }
    }

    hideModuleHeader() {
        const moduleHeader = this.querySelector<HTMLElement>(".mln-module-header")

        if (moduleHeader)
            moduleHeader.style.display = "none"
    }

    showModuleHeader() {
        const moduleHeader = this.querySelector<HTMLElement>(".mln-module-header")

        if (moduleHeader)
            moduleHeader.style.display = "flex"
    }
}

register("millennium-browser", MillenniumBrowser);

export class MillenniumFrame implements IMillenniumFrame {
    private _isProcessing: boolean = false;
    private _bodyElement: HTMLElement
    private _tabElement: HTMLElement
    private _navElement: HTMLElement
    private _moduleName: string = ""
    private _key: any
    private _route: IRoute | undefined

    constructor(public readonly browser: MillenniumBrowser) {
        //create tab on the top navbar        
        let newTab = document.createElement("li")
        newTab.className = "active"
        newTab.innerHTML = "<a href='' style='float:left'></a><i class='fa fa-times nav-btn-close' style='margin-left:auto'></span>"
        const headerUl = this.browser.querySelector("#header ul")
        if (headerUl)
            headerUl.appendChild(newTab)

        //create tab on the left navbar        
        let newTabLeft = document.createElement("li")
        newTabLeft.className = "active"
        newTabLeft.style.width = "100%"
        newTabLeft.style.float = "left"
        newTabLeft.innerHTML = "<a href='' style='float:left'></a><i class='fa fa-times nav-btn-close' style='margin-left:auto;font-size:0.8em'></i>"
        const headerLeftUl = this.browser.querySelector("#header-left ul")
        if (headerLeftUl)
            headerLeftUl.appendChild(newTabLeft)

        let newSheet = document.createElement("div")
        newSheet.className = "mln-content-frame"

        const contentFrame = this.browser.querySelector("#content-frame")
        if (contentFrame)
            contentFrame.appendChild(newSheet)

        newTabLeft.onclick = (e) => this.handleTabClick(e)
        newTab.onclick = (e) => this.handleTabClick(e);

        (newTab as any)[mlnTabSheetSymbol] = newSheet;
        (newTabLeft as any)[mlnTabSheetSymbol] = newSheet;

        this._bodyElement = newSheet
        this._tabElement = newTab
        this._navElement = newTabLeft

        browser[FRAMES].add(this)
    }
    insertTabsAfter(reference: MillenniumFrame) {
        const refTab = reference._tabElement;
        if (refTab?.parentElement === this._tabElement.parentElement) {
            refTab.parentElement?.insertBefore(this._tabElement, refTab.nextSibling);
        }
        const refNav = reference._navElement;
        if (refNav?.parentElement === this._navElement.parentElement) {
            refNav.parentElement?.insertBefore(this._navElement, refNav.nextSibling);
        }
    }
    replaceElement(newEl: HTMLElement) {
        const oldEl = this._bodyElement
        newEl.className = oldEl.className
        for (const attr of Array.from(oldEl.attributes)) {
            if (attr.name !== 'class')
                newEl.setAttribute(attr.name, attr.value)
        }
        // Atualiza a referência ANTES do replaceChild — o `connectedCallback` do `newEl`
        // (custom element via @Component) dispara síncrono dentro do replaceChild, e seu
        // `onInit`/`onAfterFirstRender` lê `frame.element`. Se atualizamos depois, o módulo
        // ainda enxerga o `oldEl` durante toda a primeira render.
        this._bodyElement = newEl
            ; (this._tabElement as any)[mlnTabSheetSymbol] = newEl
            ; (this._navElement as any)[mlnTabSheetSymbol] = newEl
        oldEl.parentNode!.replaceChild(newEl, oldEl)
    }
    get key() {
        return this._key
    }
    set key(value) {
        this._key = value
    }
    get route(): IRoute | undefined {
        return this._route
    }
    set route(value: IRoute | undefined) {
        this._route = value
        if (value?.target === "home") {
            const navClose = this._navElement.querySelector<HTMLElement>(".nav-btn-close")
            const tabClose = this._tabElement.querySelector<HTMLElement>(".nav-btn-close")
            for (const el of [navClose, tabClose]) {
                if (!el) continue
                el.style.opacity = "0"
                el.style.pointerEvents = "none"
                el.setAttribute("disabled", "true")
                el.setAttribute("aria-hidden", "true")
            }
        }
    }
    get isActive() {
        return this._tabElement.classList.contains("active")
    }
    get caption(): string {
        return this._tabElement.querySelector("a")?.text ?? ""
    }
    get moduleName() {
        return this._moduleName
    }
    set moduleName(value: string) {
        this._moduleName = value
        this._bodyElement.setAttribute("data-module-name", value)
        this._tabElement.setAttribute("data-module-name", value)
        this._navElement.setAttribute("data-module-name", value)
    }
    get visible() {
        return !this._tabElement.hidden
    }
    set visible(value: boolean) {
        this._bodyElement.hidden = !value || !this._bodyElement.classList.contains("visible")
        this._tabElement.hidden = !value || !this._tabElement.classList.contains("visible")
        this._navElement.hidden = !value || !this._navElement.classList.contains("visible")
    }
    requestFullScreen() {
        const navbar = this.browser.querySelector<HTMLElement>('.navbar')
        if (navbar)
            navbar.style.display = "none"
    }
    async switchUser(): Promise<void> {

    }
    async accessPrompt(message: string, key: string, userInfo?: any) {
        return this.browser.accessPrompt(message, key, userInfo)
    }
    async hasAccess(key: string | string[]) {
        if (typeof key === "string") {
            const access = await this.browser.hasAccess(key);

            if (typeof access === "object" && access !== null && "hasAccess" in access) {
                return !!(access as { hasAccess: boolean }).hasAccess;
            }

            return !!access;
        } else {
            const result: any = {}
            for (const item of key)
                result[item] = (await this.browser.hasAccess(item))
            return result
        }
    }
    private async closeTab(tabElement: HTMLElement) {
        let tabEl = tabElement

        let lasttab = tabEl.previousElementSibling
        while (lasttab) {
            if (lasttab.getAttribute("data-module-name") !== this._moduleName)
                lasttab = lasttab.previousElementSibling
            else
                break
        }

        if (!lasttab) {
            lasttab = tabEl.nextElementSibling
            while (lasttab) {
                if (lasttab.getAttribute("data-module-name") !== this._moduleName)
                    lasttab = lasttab.nextElementSibling
                else
                    break
            }
        }

        let wasActive = tabEl.classList.contains("active")
        let module = (tabEl as any)[mlnTabSheetSymbol][mlnModuleInstanceSymbol]
        if (module) {
            if (module.OnDestroy)
                await module.OnDestroy()
            else if (module.destroy)
                await module.destroy()
            module.frame = null
        }
        (tabEl as any)[mlnTabSheetSymbol][mlnModuleInstanceSymbol] = null
            ; (tabEl as any)[mlnTabSheetSymbol].remove()
        tabEl.remove()

        if (lasttab && wasActive) {
            (lasttab as HTMLElement).click()
        } else {
            // Fechou a aba ATIVA e não há irmã do mesmo módulo para assumir: zera o
            // estado de módulo/aba do browser para que reabrir o MESMO link volte a
            // carregar (senão o guard `currentModuleName === moduleName` em showModule
            // aborta e só volta a funcionar após visitar outro módulo e retornar).
            if (wasActive)
                this.browser.resetActiveModule()
            if (!millennium.browser.isEmbedded) {
                // Fechar uma aba não pode apagar a rota da URL enquanto ainda houver aba ativa.
                // Este ramo também roda quando a busca por `lasttab` acima não casa (as abas podem
                // ter `data-module-name` vazio), embora outra aba assuma o foco: nesse caso a
                // seleção ficava correta mas a URL era zerada, e o reload seguinte caía na home.
                // Publica o href da aba que assumiu; só zera quando não sobrou nenhuma.
                const activeLink = document.querySelector<HTMLAnchorElement>("#header ul li.active a[href*='#']")
                const activeHref = activeLink?.getAttribute("href") || ""
                const hashIdx = activeHref.indexOf("#")
                if (hashIdx >= 0)
                    history.pushState(null, "", activeHref.substring(hashIdx))
                else
                    history.pushState("", document.title, window.location.pathname)
            }
        }
    }
    private async activateTab(tabElement: HTMLElement) {
        let tabEl = tabElement.closest("li")
        if (!tabEl) return

        //deactivate others tabs
        if (tabEl.parentElement)
            Array.from(tabEl.parentElement.children).filter((e) => e !== tabEl && e.getAttribute("data-module-name") === this._moduleName).forEach(e => e.classList.remove("active"))
        //content — itera TODOS os filhos: paginas @Component substituem o div legado por
        //custom elements (pos-sales, etc) via replaceElement. Limitar a "> div" deixa
        //frames anteriores marcados como active+visible — sobrepoem a aba ativa.
        const contentFrame = this.browser.querySelector("#content-frame")
        if (contentFrame) Array.from(contentFrame.children).forEach(e => {
            const isOurTabSheet = e === (tabEl as any)[mlnTabSheetSymbol]
            if (!isOurTabSheet && e.getAttribute("data-module-name") === this._moduleName) {
                e.classList.remove("active", "visible");
                (e as HTMLElement).setAttribute("hidden", "true");
                const otherModuleInst = (e as any)[mlnModuleInstanceSymbol]
                if (otherModuleInst && typeof otherModuleInst.setActive === "function") {
                    try { otherModuleInst.setActive(false) } catch (err) { console.error(err) }
                }
            }
        })

        //activate this
        tabEl.classList.add("active", "visible")
        tabEl.removeAttribute("hidden")
        document.title = (!this.browser.isEmbedded ? "Millennium ● " : "") + (<HTMLAnchorElement>tabElement).text;

        (tabEl as any)[mlnTabSheetSymbol].classList.add("visible", "active");
        (tabEl as any)[mlnTabSheetSymbol].removeAttribute("hidden");

        const frame = (tabEl as any)[mlnTabSheetSymbol][mlnModuleInstanceSymbol]
        if (frame && frame.activate) await frame.activate()
        if (frame && typeof frame.setActive === "function") {
            try { frame.setActive(true) } catch (err) { console.error(err) }
        }
        if (!this.browser.isEmbedded)
            history.pushState(null, "", (tabElement as HTMLLinkElement).href.substring((tabElement as HTMLLinkElement).href.indexOf("#")))
    }
    private async activateTabs() {
        const navLink = this._navElement.querySelector("a")
        const tabLink = this._tabElement.querySelector("a")
        if (navLink)
            await this.activateTab(navLink)
        if (tabLink)
            await this.activateTab(tabLink)
        window.dispatchEvent(new Event("resize"))
    }
    handleTabClick = async (e: Event) => {
        if (!e.target) return
        e.preventDefault()

        if ((e.target as HTMLElement).classList.contains("nav-btn-close") && (e.target as HTMLElement).closest("li")?.classList.contains("active"))
            await this.close()
        else
            await this.activateTabs()
    }
    navigateSc(key: string, data: string, vars: Object, caption?: any) {
        return this.browser.frame_navigateSc(this, key, data, vars, caption)
    };
    navigate(place: string, vars?: Object) {
        return this.browser.frame_navigate(this, place, vars || {})
    };
    close = async () => {
        if (this._route?.target === "home") return
        const navBtnClose = this._navElement.querySelector(".nav-btn-close")
        const tabBtnClose = this._tabElement.querySelector(".nav-btn-close")
        if (navBtnClose && navBtnClose.parentElement)
            await this.closeTab(navBtnClose.parentElement as HTMLElement)
        if (tabBtnClose && tabBtnClose.parentElement)
            await this.closeTab(tabBtnClose.parentElement as HTMLElement)
        this._bodyElement.remove()

        this.browser.frame_close(this)
        this.browser[FRAMES].delete(this)
    };
    setCaption(value: string) {
        const tabLink = this._tabElement.querySelector("a")
        const navLink = this._navElement.querySelector("a")
        if (tabLink) tabLink.text = value
        if (navLink) navLink.text = value
        this.browser.frame_setCaption(this, value)
    };
    setUrl(value: string) {
        const tabLink = this._tabElement.querySelector("a")
        const navLink = this._navElement.querySelector("a")
        if (tabLink) tabLink.href = value
        if (navLink) navLink.href = value
        this.browser.frame_setUrl(this, value)
    };
    activate() {
        const prev = this.browser._activeFrame
        if (prev && prev !== this) {
            try { prev.deactivate() } catch (e) { console.error(e) }
        }
        this.activateTabs()
        this.browser._activeFrame = this
        const module = (this._bodyElement as any)[mlnModuleInstanceSymbol]
        if (module && typeof module.setActive === "function") {
            try { module.setActive(true) } catch (e) { console.error(e) }
        }
        this.browser.frame_activate(this)
    };
    deactivate() {
        const module = (this._bodyElement as any)[mlnModuleInstanceSymbol]
        if (module && typeof module.setActive === "function") {
            try { module.setActive(false) } catch (e) { console.error(e) }
        }
        this.browser.frame_deactivate(this)
    };
    get element(): HTMLElement {
        return this._bodyElement
    };
    set isProcessing(value: boolean) {
        this._isProcessing = value
    };
    get isProcessing() {
        return this._isProcessing
    }

    getActivityElement(element?: HTMLElement): MlnActivityIndicator | undefined {
        return (element ?? this._bodyElement).querySelector(":scope > mln-activity-indicator") as MlnActivityIndicator | undefined
    }
    beginProcessing(element?: HTMLElement): MlnActivityIndicator {

        const parentEl = element ?? this._bodyElement
        let activityEl = parentEl.querySelector(":scope > mln-activity-indicator") as MlnActivityIndicator | undefined

        if (!activityEl) {
            activityEl = document.createElement("mln-activity-indicator")
            parentEl.appendChild(activityEl)
        }

        activityEl.begin()

        return activityEl
    }
    endProcessing(error?: string, element?: HTMLElement) {
        if (error) this.browser.notify(error, "warning")
        this.getActivityElement(element)?.end()
    }
    lazyLoad(lazyFacet: LazyLoadFacet, callback: () => void): void {
        if (lazyFacet.timer) clearInterval(lazyFacet.timer)
        lazyFacet.timer = setTimeout(() => {
            callback()
        }, lazyFacet.delay)
    }
    notify(message: string, type: "warning" | "danger" | "success" | "warning-auto-hide") {
        this.browser.notify(message, type)
        this.browser.frame_notify(this, message, type)
    }
    activity<T extends PromiseLike<any>>(waiter: T, feedBackData?: FeedBackData, silent?: boolean, transaction: string | undefined = undefined): T {

        if (!waiter.then) return waiter
        let currentMessage = 1
        let messageTimer: any | undefined
        const targetEl = feedBackData?.element ?? getTopOverlayElement()
        const activityEl = this.beginProcessing(targetEl)
        if (transaction)
            this.getActivityElement(targetEl)?.transaction(transaction)

        const handleError = (error: any) => {
            this.endProcessing(silent ? undefined : error, targetEl)
            clearInterval(messageTimer)
            return Promise.reject(error) as any
        }

        try {
            if (feedBackData) {
                if (activityEl)
                    activityEl.caption = (feedBackData.waitMessages?.[0]) ?? ""
                if (feedBackData.waitMessages && feedBackData.estimatedTime)
                    messageTimer = setInterval(() => {
                        if (activityEl)
                            activityEl.caption = feedBackData.waitMessages?.[currentMessage] ?? ""
                        currentMessage++
                        if (currentMessage >= (feedBackData.waitMessages?.length ?? 0)) clearInterval(messageTimer)
                    }, feedBackData.estimatedTime / feedBackData.waitMessages.length)
            } else
                if (activityEl)
                    activityEl.caption = ""

            return waiter.then((result: any) => {
                this.endProcessing(undefined, targetEl)
                clearInterval(messageTimer)
                return result
            }, handleError) as any
        } catch (error: any) {
            return handleError(error)
        }
    }
    async loadExtension(name: string): Promise<any> {
        return this.browser.loadExtension(name)
    }
}
